window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.innerHTML="";
 linkmsg.style.visibility="hidden";
 sizemsg.style.visibility="hidden";
// opmsg.style.visibility="hidden";
}
//カート中身リセット
function cartReset(){
    document.getElementById("price").value=""
    cart_price.innerHTML =""+" 円";
    cart_haba.innerHTML=""; 
    cart_depth.innerHTML=""; 
    cart_height.innerHTML="";
    cart_color.innerHTML="";
//    cart_option.innerHTML="";
    linkmsg.style.visibility="hidden";
}
//リアルタイムサイズチェック
function changeMsg(){
    var intDepth=document.getElementById("depth").value;
    var intHaba=document.getElementById("haba").value;
    var intHeight=document.getElementById("height").value;
    sizemsg.style.visibility="hidden";
    cartReset();
    if (intHaba == ""){document.getElementById("inner_haba").innerHTML = "　";}
    if (intDepth == ""){document.getElementById("inner_depth").innerHTML = "　";}
    if (intHeight == ""){document.getElementById("inner_height").innerHTML = "　";}
    if (intDepth==""||intHaba==""||intHeight==""){
        document.getElementById("sizemsg").innerHTML = "<p> </p>";
     sizemsg.style.visibility="hidden";
        return false;
    }
    if (intHaba < 90 || intHaba > 180){document.getElementById("sizemsg").innerHTML = "<p>※ 幅90cm未満・幅181cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intDepth < 30 || intDepth > 60){document.getElementById("sizemsg").innerHTML = "<p>※ 奥行30cm未満・奥行61cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    if (intHeight < 30 || intHeight > 55){document.getElementById("sizemsg").innerHTML = "<p>※ 高さ30cm未満・高さ56cm以上はオーダー不可です ※</p>";sizemsg.style.visibility="visible";return false;}
    document.getElementById("sizemsg").innerHTML = "<p> </p>"
    
    //小サイズ表示用
    var valueHaba = intHaba-16;
    var valueDepth = intDepth;
    var valueHeight = intHeight-8;
    document.getElementById("inner_haba").innerHTML= "約"+valueHaba;
    document.getElementById("inner_depth").innerHTML= "約"+valueDepth;
    document.getElementById("inner_height").innerHTML= "約"+valueHeight;
    
 sizemsg.style.visibility="hidden";
}

/*function changeOp(){
    cartReset();
}*/

//オプション
/*
function changeOp(){
    checkBoxhaisen = document.frm_detail.op_haisen.checked;
    checkBoxhabaki = document.frm_detail.op_habaki.checked;
    opmsg.style.visibility="hidden";
    linkmsg.style.visibility="hidden";
    if (checkBoxhaisen==true || checkBoxhabaki==true){
        document.getElementById("opmsg").innerHTML = "<p>※大小セットの両方に加工がされます</p>";
     opmsg.style.visibility="visible";
        cartReset();
        return false;
    }
    opmsg.style.visibility="hidden";
    cartReset();
}
*/

//サイズオーダー
const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_blank\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,depth,height,color,price){
this.url=url;this.haba=haba;this.depth=depth;this.height=height;this.color=color;this.price=price;}
function searchURL(strHaba,strDepth,strHeight,strColor){
var strErr;
var intHaba=document.getElementById("haba").value
var intDepth=document.getElementById("depth").value
var intHeight=document.getElementById("height").value

//サイズチェック
if (intHaba < 90 || intHaba > 180){strErr="幅90cm未満・幅181cm以上は";}
else if (intDepth < 30 || intDepth > 60){strErr="奥行30cm未満・奥行61cm以上は";}
else if (intHeight < 30 || intHeight > 55){strErr="高さ30cm未満・高さ56cm以上は";}
if(strErr){document.getElementById("price").value="";
return strErr+"オーダー不可です。";}

//幅サイズ成形
if (strHaba.slice(-1)>=1 && strHaba.slice(-1)<=5){strHaba=strHaba.slice(0,strHaba.length-1) +"5";}
else if (strHaba.slice(-1)>=6 && strHaba.slice(-1)<=9){strHaba=parseInt(strHaba.slice(0,strHaba.length-1)) + 1 +"0";}

//奥行サイズ成形
if (strDepth.slice(-1)>=1 && strDepth.slice(-1)<=5){strDepth=strDepth.slice(0,strDepth.length-1) +"5";}
else if (strDepth.slice(-1)>=6 && strDepth.slice(-1)<=9){strDepth=parseInt(strDepth.slice(0,strDepth.length-1)) + 1 +"0";}

//高さサイズ成形
switch(intHeight != null){
  case intHeight <= 30: //高さ30cm以下のとき
    strHeight = 30;
    break;
  case intHeight <= 45: //高さ45cm以下のとき
    strHeight = 45;
    break;
  case intHeight <= 50: //高さ50cm以下のとき
    strHeight = 50;
    break;
  case intHeight <= 55: //高さ55cm以下のとき
    strHeight = 55;
    break;
}

//ベース価格
var basePriceA = [32000,34000,36000,38000]; //化粧紙・aino
var basePriceB = [51000,56000,61000,66000]; //nail・black
var basePriceC = [54000,59000,64000,69000]; //bp
var basePriceD = [63000,68000,73000,78000]; //mb・gs・ww
var addPrice = [1000,3000,5000,8000];
var sellPrice;

var Column=(strHaba-90)/5;
var Row=(strDepth-30)/5;

if(strHeight == 30){//▼高さ30cm▼
    if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[0]+(Column*addPrice[0]+Row*addPrice[1]);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[0]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "bp"){sellPrice = basePriceC[0]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[0]+(Column*addPrice[0]+Row*addPrice[3]);}
  }
else if(strHeight == 45){//▼高さ31～45cm▼
    if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[1]+(Column*addPrice[0]+Row*addPrice[1]);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[1]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "bp"){sellPrice = basePriceC[1]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[1]+(Column*addPrice[0]+Row*addPrice[3]);}
  }
else if(strHeight == 50){//▼高さ46～50cm▼
    if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[2]+(Column*addPrice[0]+Row*addPrice[1]);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[2]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "bp"){sellPrice = basePriceC[2]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[2]+(Column*addPrice[0]+Row*addPrice[3]);}
  }
else if(strHeight == 55){//▼高さ51～55cm▼
    if(strColor=="wood" || strColor=="aino"){sellPrice = basePriceA[3]+(Column*addPrice[0]+Row*addPrice[1]);}
    else if(strColor == "nail" || strColor == "black"){sellPrice = basePriceB[3]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "bp"){sellPrice = basePriceC[3]+(Column*addPrice[0]+Row*addPrice[2]);}
    else if(strColor == "gs" || strColor == "mb" || strColor == "ww"){sellPrice = basePriceD[3]+(Column*addPrice[0]+Row*addPrice[3]);}
  }
 return sellPrice;
}



/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strHeight,strColor){
switch(true){
 default:
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].height==strHeight && goods[i].color==strColor){
return goods[i].url;}}
  break;
return false;
}
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
cartReset();
    
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=document.getElementById("depth").value;
var strHaba=document.getElementById("haba").value;
var strHeight=document.getElementById("height").value;
var idColor = document.getElementsByName("colortype") ;
//var idOption = document.getElementsByName("option") ;
var strColor = "";
//var strOption = "";
var strInner_haba = "";
var strInner_depth = "";
var strInner_height = "";
var i=0;
var c=0;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
     if( idColor[i].id.slice(0,4)=="wood" ){
         strColor = idColor[i].id.slice(0,4);
     }else if( idColor[i].id.slice(0,4)=="aino" ){
         strColor = idColor[i].id.slice(0,4);
     }else{
         strColor = idColor[i].id;
     }
  var valueColor = idColor[i].value ;
  break ;
 }
}
var total = 0;
/*for ( c = idOption.length; c--; ) {
 if ( idOption[c].checked ) {
     total++;
     if( strOption == "" ) {
         strOption = idOption[c].id;
         var valueOption = idOption[c].value;
     }else if( strOption != "" ) {
         var valueOption = valueOption+"、"+idOption[c].value;
     }
 }
}
if(typeof valueOption=== "undefined"){
     valueOption="オプション無し";
 }*/



if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
if (isNumber(strDepth)==false){
alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (isNumber(strHeight)==false){
alert("高さは『1以上の整数(小数点不可/半角文字）』をご入力ください");
return false;
}
if (strColor==false){
alert("カラーを選択してください");
return false;
}
document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strDepth+"cm"
document.getElementById("choice3").value=strHeight+"cm"
document.getElementById("choice4").value=valueColor
//document.getElementById("choice5").value="オプション：" +valueOption+"/"
//商品ページの有無チェック
var comcode=checkURL(strHaba,strDepth,strHeight,strColor);
//if (!comcode=="" && valueOption=="オプション無し"){
if(valueColor=="強化紙ブラックウッド"){
if (!comcode==""){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML=valueColor+"は別注色のため既製品とは金額が異なります。";
}}
else if (!comcode==""){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
var url=searchURL(strHaba,strDepth,strHeight,strColor);

if(!url){
alert("幅、奥行を選んでください");
return false;
}

var intUnit;
if (isNaN(url)==false){
 if(total>0){
     total=total*3000;
 }
 intUnit=(parseInt(url)+total)/1000;
 document.getElementById("price").value =(parseInt(url)+total).toLocaleString()+" 円";
 cart_price.innerHTML =(parseInt(url)+total).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_depth.innerHTML=strDepth;
 cart_height.innerHTML=strHeight;
 cart_color.innerHTML=valueColor;
// cart_option.innerHTML=valueOption;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice6").value="見積もり金額："+(parseInt(url)+total);
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;  
 var choice3=document.frm.choice3.value;
 var choice4=document.frm.choice4.value;  
// var choice5=document.frm.choice5.value;  
 var choice6=document.frm.choice6.value;  
 var text = document.frm.inventory_id.value;
 var price = document.frm_detail.price.value;
 if(choice1=="" || choice2=="" || choice3=="") {
     alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
     return false;
 }
 if(price=="") {
     alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
     return false;
 }       
 return true;
}



goods = new Object();
goods[0] =new setGoods("0000a68774","90","30","30","wood","23000");
goods[1] =new setGoods("0000a68865","90","35","30","wood","26000");
goods[2] =new setGoods("0000a57383","90","40","30","wood","29000");
goods[3] =new setGoods("0000a69040","90","45","30","wood","32000");
goods[4] =new setGoods("0000a69117","90","50","30","wood","35000");
goods[5] =new setGoods("0000a69201","90","55","30","wood","38000");
goods[6] =new setGoods("0000a69278","90","60","30","wood","41000");
goods[7] =new setGoods("0000a68781","95","30","30","wood","24000");
goods[8] =new setGoods("0000a68872","95","35","30","wood","27000");
goods[9] =new setGoods("0000a68956","95","40","30","wood","30000");
goods[10] =new setGoods("0000a69047","95","45","30","wood","33000");
goods[11] =new setGoods("0000a69124","95","50","30","wood","36000");
goods[12] =new setGoods("0000a69208","95","55","30","wood","39000");
goods[13] =new setGoods("0000a69285","95","60","30","wood","42000");
goods[14] =new setGoods("0000a68788","100","30","30","wood","25000");
goods[15] =new setGoods("0000a68879","100","35","30","wood","28000");
goods[16] =new setGoods("0000a68963","100","40","30","wood","31000");
goods[17] =new setGoods("0000a57390","100","45","30","wood","34000");
goods[18] =new setGoods("0000a69131","100","50","30","wood","37000");
goods[19] =new setGoods("0000a69215","100","55","30","wood","40000");
goods[20] =new setGoods("0000a69292","100","60","30","wood","43000");
goods[21] =new setGoods("0000a68795","105","30","30","wood","26000");
goods[22] =new setGoods("0000a68886","105","35","30","wood","29000");
goods[23] =new setGoods("0000a68970","105","40","30","wood","32000");
goods[24] =new setGoods("0000a69054","105","45","30","wood","35000");
goods[25] =new setGoods("0000a69138","105","50","30","wood","38000");
goods[26] =new setGoods("0000a69222","105","55","30","wood","41000");
goods[27] =new setGoods("0000a69299","105","60","30","wood","44000");
goods[28] =new setGoods("0000a68802","110","30","30","wood","27000");
goods[29] =new setGoods("0000a68893","110","35","30","wood","30000");
goods[30] =new setGoods("0000a68977","110","40","30","wood","33000");
goods[31] =new setGoods("0000a57397","110","45","30","wood","36000");
goods[32] =new setGoods("0000a69145","110","50","30","wood","39000");
goods[33] =new setGoods("0000a69229","110","55","30","wood","42000");
goods[34] =new setGoods("0000a69306","110","60","30","wood","45000");
goods[35] =new setGoods("0000a68809","115","30","30","wood","28000");
goods[36] =new setGoods("0000a68900","115","35","30","wood","31000");
goods[37] =new setGoods("0000a68984","115","40","30","wood","34000");
goods[38] =new setGoods("0000a69061","115","45","30","wood","37000");
goods[39] =new setGoods("0000a69152","115","50","30","wood","40000");
goods[40] =new setGoods("0000a69236","115","55","30","wood","43000");
goods[41] =new setGoods("0000a69313","115","60","30","wood","46000");
goods[42] =new setGoods("0000a68816","120","30","30","wood","29000");
goods[43] =new setGoods("0000a68907","120","35","30","wood","32000");
goods[44] =new setGoods("0000a68991","120","40","30","wood","35000");
goods[45] =new setGoods("0000a69068","120","45","30","wood","38000");
goods[46] =new setGoods("0000a57404","120","50","30","wood","41000");
goods[47] =new setGoods("0000a69243","120","55","30","wood","44000");
goods[48] =new setGoods("0000a69320","120","60","30","wood","47000");
goods[49] =new setGoods("0000a68823","125","30","30","wood","30000");
goods[50] =new setGoods("0000a68914","125","35","30","wood","33000");
goods[51] =new setGoods("0000a68998","125","40","30","wood","36000");
goods[52] =new setGoods("0000a69075","125","45","30","wood","39000");
goods[53] =new setGoods("0000a69159","125","50","30","wood","42000");
goods[54] =new setGoods("0000a69250","125","55","30","wood","45000");
goods[55] =new setGoods("0000a69327","125","60","30","wood","48000");
goods[56] =new setGoods("0000a68830","130","30","30","wood","31000");
goods[57] =new setGoods("0000a68921","130","35","30","wood","34000");
goods[58] =new setGoods("0000a69005","130","40","30","wood","37000");
goods[59] =new setGoods("0000a69082","130","45","30","wood","40000");
goods[60] =new setGoods("0000a69166","130","50","30","wood","43000");
goods[61] =new setGoods("0000a57411","130","55","30","wood","46000");
goods[62] =new setGoods("0000a69334","130","60","30","wood","49000");
goods[63] =new setGoods("0000a68837","135","30","30","wood","32000");
goods[64] =new setGoods("0000a68928","135","35","30","wood","35000");
goods[65] =new setGoods("0000a69012","135","40","30","wood","38000");
goods[66] =new setGoods("0000a69089","135","45","30","wood","41000");
goods[67] =new setGoods("0000a69173","135","50","30","wood","44000");
goods[68] =new setGoods("0000a69257","135","55","30","wood","47000");
goods[69] =new setGoods("0000a69341","135","60","30","wood","50000");
goods[70] =new setGoods("0000a68844","140","30","30","wood","33000");
goods[71] =new setGoods("0000a68935","140","35","30","wood","36000");
goods[72] =new setGoods("0000a69019","140","40","30","wood","39000");
goods[73] =new setGoods("0000a69096","140","45","30","wood","42000");
goods[74] =new setGoods("0000a69180","140","50","30","wood","45000");
goods[75] =new setGoods("0000a57418","140","55","30","wood","48000");
goods[76] =new setGoods("0000a69348","140","60","30","wood","51000");
goods[77] =new setGoods("0000a68851","145","30","30","wood","34000");
goods[78] =new setGoods("0000a68942","145","35","30","wood","37000");
goods[79] =new setGoods("0000a69026","145","40","30","wood","40000");
goods[80] =new setGoods("0000a69103","145","45","30","wood","43000");
goods[81] =new setGoods("0000a69187","145","50","30","wood","46000");
goods[82] =new setGoods("0000a69264","145","55","30","wood","49000");
goods[83] =new setGoods("0000a69355","145","60","30","wood","52000");
goods[84] =new setGoods("0000a68858","150","30","30","wood","35000");
goods[85] =new setGoods("0000a68949","150","35","30","wood","38000");
goods[86] =new setGoods("0000a69033","150","40","30","wood","41000");
goods[87] =new setGoods("0000a69110","150","45","30","wood","44000");
goods[88] =new setGoods("0000a69194","150","50","30","wood","47000");
goods[89] =new setGoods("0000a69271","150","55","30","wood","50000");
goods[90] =new setGoods("0000a57425","150","60","30","wood","53000");
goods[91] =new setGoods("0000a69362","90","30","42","wood","25000");
goods[92] =new setGoods("0000a69369","95","30","42","wood","26000");
goods[93] =new setGoods("0000a69376","100","30","42","wood","27000");
goods[94] =new setGoods("0000a69383","105","30","42","wood","28000");
goods[95] =new setGoods("0000a69390","110","30","42","wood","29000");
goods[96] =new setGoods("0000a69397","115","30","42","wood","30000");
goods[97] =new setGoods("0000a69404","120","30","42","wood","31000");
goods[98] =new setGoods("0000a69411","125","30","42","wood","32000");
goods[99] =new setGoods("0000a69418","130","30","42","wood","33000");
goods[100] =new setGoods("0000a69425","135","30","42","wood","34000");
goods[101] =new setGoods("0000a69432","140","30","42","wood","35000");
goods[102] =new setGoods("0000a69439","145","30","42","wood","36000");
goods[103] =new setGoods("0000a69446","150","30","42","wood","37000");
goods[104] =new setGoods("0000a69453","90","35","42","wood","28000");
goods[105] =new setGoods("0000a69460","95","35","42","wood","29000");
goods[106] =new setGoods("0000a69467","100","35","42","wood","30000");
goods[107] =new setGoods("0000a69474","105","35","42","wood","31000");
goods[108] =new setGoods("0000a69481","110","35","42","wood","32000");
goods[109] =new setGoods("0000a69488","115","35","42","wood","33000");
goods[110] =new setGoods("0000a69495","120","35","42","wood","34000");
goods[111] =new setGoods("0000a69502","125","35","42","wood","35000");
goods[112] =new setGoods("0000a69509","130","35","42","wood","36000");
goods[113] =new setGoods("0000a69516","135","35","42","wood","37000");
goods[114] =new setGoods("0000a69523","140","35","42","wood","38000");
goods[115] =new setGoods("0000a69530","145","35","42","wood","39000");
goods[116] =new setGoods("0000a69537","150","35","42","wood","40000");
goods[117] =new setGoods("0000a00049","90","40","42","wood","31000");
goods[118] =new setGoods("0000a69544","95","40","42","wood","32000");
goods[119] =new setGoods("0000a69551","100","40","42","wood","33000");
goods[120] =new setGoods("0000a69558","105","40","42","wood","34000");
goods[121] =new setGoods("0000a69565","110","40","42","wood","35000");
goods[122] =new setGoods("0000a69572","115","40","42","wood","36000");
goods[123] =new setGoods("0000a69579","120","40","42","wood","37000");
goods[124] =new setGoods("0000a69586","125","40","42","wood","38000");
goods[125] =new setGoods("0000a69593","130","40","42","wood","39000");
goods[126] =new setGoods("0000a69600","135","40","42","wood","40000");
goods[127] =new setGoods("0000a69607","140","40","42","wood","41000");
goods[128] =new setGoods("0000a69614","145","40","42","wood","42000");
goods[129] =new setGoods("0000a69621","150","40","42","wood","43000");
goods[130] =new setGoods("0000a69628","90","45","42","wood","34000");
goods[131] =new setGoods("0000a69635","95","45","42","wood","35000");
goods[132] =new setGoods("0000a57341","100","45","42","wood","36000");
goods[133] =new setGoods("0000a69642","105","45","42","wood","37000");
goods[134] =new setGoods("0000a57348","110","45","42","wood","38000");
goods[135] =new setGoods("0000a69649","115","45","42","wood","39000");
goods[136] =new setGoods("0000a69656","120","45","42","wood","40000");
goods[137] =new setGoods("0000a69663","125","45","42","wood","41000");
goods[138] =new setGoods("0000a69670","130","45","42","wood","42000");
goods[139] =new setGoods("0000a69677","135","45","42","wood","43000");
goods[140] =new setGoods("0000a69684","140","45","42","wood","44000");
goods[141] =new setGoods("0000a69691","145","45","42","wood","45000");
goods[142] =new setGoods("0000a69698","150","45","42","wood","46000");
goods[143] =new setGoods("0000a69705","90","50","42","wood","37000");
goods[144] =new setGoods("0000a69712","95","50","42","wood","38000");
goods[145] =new setGoods("0000a69719","100","50","42","wood","39000");
goods[146] =new setGoods("0000a69726","105","50","42","wood","40000");
goods[147] =new setGoods("0000a69733","110","50","42","wood","41000");
goods[148] =new setGoods("0000a69740","115","50","42","wood","42000");
goods[149] =new setGoods("0000a57355","120","50","42","wood","43000");
goods[150] =new setGoods("0000a69747","125","50","42","wood","44000");
goods[151] =new setGoods("0000a69754","130","50","42","wood","45000");
goods[152] =new setGoods("0000a69761","135","50","42","wood","46000");
goods[153] =new setGoods("0000a69768","140","50","42","wood","47000");
goods[154] =new setGoods("0000a69775","145","50","42","wood","48000");
goods[155] =new setGoods("0000a69782","150","50","42","wood","49000");
goods[156] =new setGoods("0000a69789","90","55","42","wood","40000");
goods[157] =new setGoods("0000a69796","95","55","42","wood","41000");
goods[158] =new setGoods("0000a69803","100","55","42","wood","42000");
goods[159] =new setGoods("0000a69810","105","55","42","wood","43000");
goods[160] =new setGoods("0000a69817","110","55","42","wood","44000");
goods[161] =new setGoods("0000a69824","115","55","42","wood","45000");
goods[162] =new setGoods("0000a69831","120","55","42","wood","46000");
goods[163] =new setGoods("0000a69838","125","55","42","wood","47000");
goods[164] =new setGoods("0000a57362","130","55","42","wood","48000");
goods[165] =new setGoods("0000a69845","135","55","42","wood","49000");
goods[166] =new setGoods("0000a57369","140","55","42","wood","50000");
goods[167] =new setGoods("0000a69852","145","55","42","wood","51000");
goods[168] =new setGoods("0000a69859","150","55","42","wood","52000");
goods[169] =new setGoods("0000a69866","90","60","42","wood","43000");
goods[170] =new setGoods("0000a69873","95","60","42","wood","44000");
goods[171] =new setGoods("0000a69880","100","60","42","wood","45000");
goods[172] =new setGoods("0000a69887","105","60","42","wood","46000");
goods[173] =new setGoods("0000a69894","110","60","42","wood","47000");
goods[174] =new setGoods("0000a69901","115","60","42","wood","48000");
goods[175] =new setGoods("0000a69908","120","60","42","wood","49000");
goods[176] =new setGoods("0000a69915","125","60","42","wood","50000");
goods[177] =new setGoods("0000a69922","130","60","42","wood","51000");
goods[178] =new setGoods("0000a69929","135","60","42","wood","52000");
goods[179] =new setGoods("0000a69936","140","60","42","wood","53000");
goods[180] =new setGoods("0000a69943","145","60","42","wood","54000");
goods[181] =new setGoods("0000a57376","150","60","42","wood","55000");
goods[182] =new setGoods("0000a69950","90","30","50","wood","27000");
goods[183] =new setGoods("0000a70041","90","35","50","wood","30000");
goods[184] =new setGoods("0000a70132","90","40","50","wood","33000");
goods[185] =new setGoods("0000a70223","90","45","50","wood","36000");
goods[186] =new setGoods("0000a70314","90","50","50","wood","39000");
goods[187] =new setGoods("0000a70405","90","55","50","wood","42000");
goods[188] =new setGoods("0000a70496","90","60","50","wood","45000");
goods[189] =new setGoods("0000a69957","95","30","50","wood","28000");
goods[190] =new setGoods("0000a70048","95","35","50","wood","31000");
goods[191] =new setGoods("0000a70139","95","40","50","wood","34000");
goods[192] =new setGoods("0000a70230","95","45","50","wood","37000");
goods[193] =new setGoods("0000a70321","95","50","50","wood","40000");
goods[194] =new setGoods("0000a70412","95","55","50","wood","43000");
goods[195] =new setGoods("0000a70503","95","60","50","wood","46000");
goods[196] =new setGoods("0000a69964","100","30","50","wood","29000");
goods[197] =new setGoods("0000a70055","100","35","50","wood","32000");
goods[198] =new setGoods("0000a70146","100","40","50","wood","35000");
goods[199] =new setGoods("0000a70237","100","45","50","wood","38000");
goods[200] =new setGoods("0000a70328","100","50","50","wood","41000");
goods[201] =new setGoods("0000a70419","100","55","50","wood","44000");
goods[202] =new setGoods("0000a70510","100","60","50","wood","47000");
goods[203] =new setGoods("0000a69971","105","30","50","wood","30000");
goods[204] =new setGoods("0000a70062","105","35","50","wood","33000");
goods[205] =new setGoods("0000a70153","105","40","50","wood","36000");
goods[206] =new setGoods("0000a70244","105","45","50","wood","39000");
goods[207] =new setGoods("0000a70335","105","50","50","wood","42000");
goods[208] =new setGoods("0000a70426","105","55","50","wood","45000");
goods[209] =new setGoods("0000a70517","105","60","50","wood","48000");
goods[210] =new setGoods("0000a69978","110","30","50","wood","31000");
goods[211] =new setGoods("0000a70069","110","35","50","wood","34000");
goods[212] =new setGoods("0000a70160","110","40","50","wood","37000");
goods[213] =new setGoods("0000a70251","110","45","50","wood","40000");
goods[214] =new setGoods("0000a70342","110","50","50","wood","43000");
goods[215] =new setGoods("0000a70433","110","55","50","wood","46000");
goods[216] =new setGoods("0000a70524","110","60","50","wood","49000");
goods[217] =new setGoods("0000a69985","115","30","50","wood","32000");
goods[218] =new setGoods("0000a70076","115","35","50","wood","35000");
goods[219] =new setGoods("0000a70167","115","40","50","wood","38000");
goods[220] =new setGoods("0000a70258","115","45","50","wood","41000");
goods[221] =new setGoods("0000a70349","115","50","50","wood","44000");
goods[222] =new setGoods("0000a70440","115","55","50","wood","47000");
goods[223] =new setGoods("0000a70531","115","60","50","wood","50000");
goods[224] =new setGoods("0000a69992","120","30","50","wood","33000");
goods[225] =new setGoods("0000a70083","120","35","50","wood","36000");
goods[226] =new setGoods("0000a70174","120","40","50","wood","39000");
goods[227] =new setGoods("0000a70265","120","45","50","wood","42000");
goods[228] =new setGoods("0000a70356","120","50","50","wood","45000");
goods[229] =new setGoods("0000a70447","120","55","50","wood","48000");
goods[230] =new setGoods("0000a70538","120","60","50","wood","51000");
goods[231] =new setGoods("0000a69999","125","30","50","wood","34000");
goods[232] =new setGoods("0000a70090","125","35","50","wood","37000");
goods[233] =new setGoods("0000a70181","125","40","50","wood","40000");
goods[234] =new setGoods("0000a70272","125","45","50","wood","43000");
goods[235] =new setGoods("0000a70363","125","50","50","wood","46000");
goods[236] =new setGoods("0000a70454","125","55","50","wood","49000");
goods[237] =new setGoods("0000a70545","125","60","50","wood","52000");
goods[238] =new setGoods("0000a70006","130","30","50","wood","35000");
goods[239] =new setGoods("0000a70097","130","35","50","wood","38000");
goods[240] =new setGoods("0000a70188","130","40","50","wood","41000");
goods[241] =new setGoods("0000a70279","130","45","50","wood","44000");
goods[242] =new setGoods("0000a70370","130","50","50","wood","47000");
goods[243] =new setGoods("0000a70461","130","55","50","wood","50000");
goods[244] =new setGoods("0000a70552","130","60","50","wood","53000");
goods[245] =new setGoods("0000a70013","135","30","50","wood","36000");
goods[246] =new setGoods("0000a70104","135","35","50","wood","39000");
goods[247] =new setGoods("0000a70195","135","40","50","wood","42000");
goods[248] =new setGoods("0000a70286","135","45","50","wood","45000");
goods[249] =new setGoods("0000a70377","135","50","50","wood","48000");
goods[250] =new setGoods("0000a70468","135","55","50","wood","51000");
goods[251] =new setGoods("0000a70559","135","60","50","wood","54000");
goods[252] =new setGoods("0000a70020","140","30","50","wood","37000");
goods[253] =new setGoods("0000a70111","140","35","50","wood","40000");
goods[254] =new setGoods("0000a70202","140","40","50","wood","43000");
goods[255] =new setGoods("0000a70293","140","45","50","wood","46000");
goods[256] =new setGoods("0000a70384","140","50","50","wood","49000");
goods[257] =new setGoods("0000a70475","140","55","50","wood","52000");
goods[258] =new setGoods("0000a70566","140","60","50","wood","55000");
goods[259] =new setGoods("0000a70027","145","30","50","wood","38000");
goods[260] =new setGoods("0000a70118","145","35","50","wood","41000");
goods[261] =new setGoods("0000a70209","145","40","50","wood","44000");
goods[262] =new setGoods("0000a70300","145","45","50","wood","47000");
goods[263] =new setGoods("0000a70391","145","50","50","wood","50000");
goods[264] =new setGoods("0000a70482","145","55","50","wood","53000");
goods[265] =new setGoods("0000a70573","145","60","50","wood","56000");
goods[266] =new setGoods("0000a70034","150","30","50","wood","39000");
goods[267] =new setGoods("0000a70125","150","35","50","wood","42000");
goods[268] =new setGoods("0000a70216","150","40","50","wood","45000");
goods[269] =new setGoods("0000a70307","150","45","50","wood","48000");
goods[270] =new setGoods("0000a70398","150","50","50","wood","51000");
goods[271] =new setGoods("0000a70489","150","55","50","wood","54000");
goods[272] =new setGoods("0000a70580","150","60","50","wood","57000");
goods[273] =new setGoods("0000a79989","90","30","30","aino","23000");
goods[274] =new setGoods("0000a80067","90","35","30","aino","26000");
goods[275] =new setGoods("0000a80145","90","40","30","aino","29000");
goods[276] =new setGoods("0000a80223","90","45","30","aino","32000");
goods[277] =new setGoods("0000a80301","90","50","30","aino","35000");
goods[278] =new setGoods("0000a80379","90","55","30","aino","38000");
goods[279] =new setGoods("0000a80457","90","60","30","aino","41000");
goods[280] =new setGoods("0000a79995","95","30","30","aino","24000");
goods[281] =new setGoods("0000a80073","95","35","30","aino","27000");
goods[282] =new setGoods("0000a80151","95","40","30","aino","30000");
goods[283] =new setGoods("0000a80229","95","45","30","aino","33000");
goods[284] =new setGoods("0000a80307","95","50","30","aino","36000");
goods[285] =new setGoods("0000a80385","95","55","30","aino","39000");
goods[286] =new setGoods("0000a80463","95","60","30","aino","42000");
goods[287] =new setGoods("0000a80001","100","30","30","aino","25000");
goods[288] =new setGoods("0000a80079","100","35","30","aino","28000");
goods[289] =new setGoods("0000a80157","100","40","30","aino","31000");
goods[290] =new setGoods("0000a80235","100","45","30","aino","34000");
goods[291] =new setGoods("0000a80313","100","50","30","aino","37000");
goods[292] =new setGoods("0000a80391","100","55","30","aino","40000");
goods[293] =new setGoods("0000a80469","100","60","30","aino","43000");
goods[294] =new setGoods("0000a80007","105","30","30","aino","26000");
goods[295] =new setGoods("0000a80085","105","35","30","aino","29000");
goods[296] =new setGoods("0000a80163","105","40","30","aino","32000");
goods[297] =new setGoods("0000a80241","105","45","30","aino","35000");
goods[298] =new setGoods("0000a80319","105","50","30","aino","38000");
goods[299] =new setGoods("0000a80397","105","55","30","aino","41000");
goods[300] =new setGoods("0000a80475","105","60","30","aino","44000");
goods[301] =new setGoods("0000a80013","110","30","30","aino","27000");
goods[302] =new setGoods("0000a80091","110","35","30","aino","30000");
goods[303] =new setGoods("0000a80169","110","40","30","aino","33000");
goods[304] =new setGoods("0000a80247","110","45","30","aino","36000");
goods[305] =new setGoods("0000a80325","110","50","30","aino","39000");
goods[306] =new setGoods("0000a80403","110","55","30","aino","42000");
goods[307] =new setGoods("0000a80481","110","60","30","aino","45000");
goods[308] =new setGoods("0000a80019","115","30","30","aino","28000");
goods[309] =new setGoods("0000a80097","115","35","30","aino","31000");
goods[310] =new setGoods("0000a80175","115","40","30","aino","34000");
goods[311] =new setGoods("0000a80253","115","45","30","aino","37000");
goods[312] =new setGoods("0000a80331","115","50","30","aino","40000");
goods[313] =new setGoods("0000a80409","115","55","30","aino","43000");
goods[314] =new setGoods("0000a80487","115","60","30","aino","46000");
goods[315] =new setGoods("0000a80025","120","30","30","aino","29000");
goods[316] =new setGoods("0000a80103","120","35","30","aino","32000");
goods[317] =new setGoods("0000a80181","120","40","30","aino","35000");
goods[318] =new setGoods("0000a80259","120","45","30","aino","38000");
goods[319] =new setGoods("0000a80337","120","50","30","aino","41000");
goods[320] =new setGoods("0000a80415","120","55","30","aino","44000");
goods[321] =new setGoods("0000a80493","120","60","30","aino","47000");
goods[322] =new setGoods("0000a80031","125","30","30","aino","30000");
goods[323] =new setGoods("0000a80109","125","35","30","aino","33000");
goods[324] =new setGoods("0000a80187","125","40","30","aino","36000");
goods[325] =new setGoods("0000a80265","125","45","30","aino","39000");
goods[326] =new setGoods("0000a80343","125","50","30","aino","42000");
goods[327] =new setGoods("0000a80421","125","55","30","aino","45000");
goods[328] =new setGoods("0000a80499","125","60","30","aino","48000");
goods[329] =new setGoods("0000a80037","130","30","30","aino","31000");
goods[330] =new setGoods("0000a80115","130","35","30","aino","34000");
goods[331] =new setGoods("0000a80193","130","40","30","aino","37000");
goods[332] =new setGoods("0000a80271","130","45","30","aino","40000");
goods[333] =new setGoods("0000a80349","130","50","30","aino","43000");
goods[334] =new setGoods("0000a80427","130","55","30","aino","46000");
goods[335] =new setGoods("0000a80505","130","60","30","aino","49000");
goods[336] =new setGoods("0000a80043","135","30","30","aino","32000");
goods[337] =new setGoods("0000a80121","135","35","30","aino","35000");
goods[338] =new setGoods("0000a80199","135","40","30","aino","38000");
goods[339] =new setGoods("0000a80277","135","45","30","aino","41000");
goods[340] =new setGoods("0000a80355","135","50","30","aino","44000");
goods[341] =new setGoods("0000a80433","135","55","30","aino","47000");
goods[342] =new setGoods("0000a80511","135","60","30","aino","50000");
goods[343] =new setGoods("0000a80049","140","30","30","aino","33000");
goods[344] =new setGoods("0000a80127","140","35","30","aino","36000");
goods[345] =new setGoods("0000a80205","140","40","30","aino","39000");
goods[346] =new setGoods("0000a80283","140","45","30","aino","42000");
goods[347] =new setGoods("0000a80361","140","50","30","aino","45000");
goods[348] =new setGoods("0000a80439","140","55","30","aino","48000");
goods[349] =new setGoods("0000a80517","140","60","30","aino","51000");
goods[350] =new setGoods("0000a80055","145","30","30","aino","34000");
goods[351] =new setGoods("0000a80133","145","35","30","aino","37000");
goods[352] =new setGoods("0000a80211","145","40","30","aino","40000");
goods[353] =new setGoods("0000a80289","145","45","30","aino","43000");
goods[354] =new setGoods("0000a80367","145","50","30","aino","46000");
goods[355] =new setGoods("0000a80445","145","55","30","aino","49000");
goods[356] =new setGoods("0000a80523","145","60","30","aino","52000");
goods[357] =new setGoods("0000a80061","150","30","30","aino","35000");
goods[358] =new setGoods("0000a80139","150","35","30","aino","38000");
goods[359] =new setGoods("0000a80217","150","40","30","aino","41000");
goods[360] =new setGoods("0000a80295","150","45","30","aino","44000");
goods[361] =new setGoods("0000a80373","150","50","30","aino","47000");
goods[362] =new setGoods("0000a80451","150","55","30","aino","50000");
goods[363] =new setGoods("0000a80529","150","60","30","aino","53000");
goods[364] =new setGoods("0000a80535","90","30","42","aino","25000");
goods[365] =new setGoods("0000a80541","95","30","42","aino","26000");
goods[366] =new setGoods("0000a80547","100","30","42","aino","27000");
goods[367] =new setGoods("0000a80553","105","30","42","aino","28000");
goods[368] =new setGoods("0000a80559","110","30","42","aino","29000");
goods[369] =new setGoods("0000a80565","115","30","42","aino","30000");
goods[370] =new setGoods("0000a80571","120","30","42","aino","31000");
goods[371] =new setGoods("0000a80577","125","30","42","aino","32000");
goods[372] =new setGoods("0000a80583","130","30","42","aino","33000");
goods[373] =new setGoods("0000a80589","135","30","42","aino","34000");
goods[374] =new setGoods("0000a80595","140","30","42","aino","35000");
goods[375] =new setGoods("0000a80601","145","30","42","aino","36000");
goods[376] =new setGoods("0000a80607","150","30","42","aino","37000");
goods[377] =new setGoods("0000a80613","90","35","42","aino","28000");
goods[378] =new setGoods("0000a80619","95","35","42","aino","29000");
goods[379] =new setGoods("0000a80625","100","35","42","aino","30000");
goods[380] =new setGoods("0000a80631","105","35","42","aino","31000");
goods[381] =new setGoods("0000a80637","110","35","42","aino","32000");
goods[382] =new setGoods("0000a80643","115","35","42","aino","33000");
goods[383] =new setGoods("0000a80649","120","35","42","aino","34000");
goods[384] =new setGoods("0000a80655","125","35","42","aino","35000");
goods[385] =new setGoods("0000a80661","130","35","42","aino","36000");
goods[386] =new setGoods("0000a80667","135","35","42","aino","37000");
goods[387] =new setGoods("0000a80673","140","35","42","aino","38000");
goods[388] =new setGoods("0000a80679","145","35","42","aino","39000");
goods[389] =new setGoods("0000a80685","150","35","42","aino","40000");
goods[390] =new setGoods("0000a39218","90","40","42","aino","31000");
goods[391] =new setGoods("0000a80691","95","40","42","aino","32000");
goods[392] =new setGoods("0000a80697","100","40","42","aino","33000");
goods[393] =new setGoods("0000a80703","105","40","42","aino","34000");
goods[394] =new setGoods("0000a80709","110","40","42","aino","35000");
goods[395] =new setGoods("0000a80715","115","40","42","aino","36000");
goods[396] =new setGoods("0000a80721","120","40","42","aino","37000");
goods[397] =new setGoods("0000a80727","125","40","42","aino","38000");
goods[398] =new setGoods("0000a80733","130","40","42","aino","39000");
goods[399] =new setGoods("0000a80739","135","40","42","aino","40000");
goods[400] =new setGoods("0000a80745","140","40","42","aino","41000");
goods[401] =new setGoods("0000a80751","145","40","42","aino","42000");
goods[402] =new setGoods("0000a80757","150","40","42","aino","43000");
goods[403] =new setGoods("0000a80763","90","45","42","aino","34000");
goods[404] =new setGoods("0000a80769","95","45","42","aino","35000");
goods[405] =new setGoods("0000a80775","100","45","42","aino","36000");
goods[406] =new setGoods("0000a80781","105","45","42","aino","37000");
goods[407] =new setGoods("0000a80787","110","45","42","aino","38000");
goods[408] =new setGoods("0000a80793","115","45","42","aino","39000");
goods[409] =new setGoods("0000a80799","120","45","42","aino","40000");
goods[410] =new setGoods("0000a80805","125","45","42","aino","41000");
goods[411] =new setGoods("0000a80811","130","45","42","aino","42000");
goods[412] =new setGoods("0000a80817","135","45","42","aino","43000");
goods[413] =new setGoods("0000a80823","140","45","42","aino","44000");
goods[414] =new setGoods("0000a80829","145","45","42","aino","45000");
goods[415] =new setGoods("0000a80835","150","45","42","aino","46000");
goods[416] =new setGoods("0000a80841","90","50","42","aino","37000");
goods[417] =new setGoods("0000a80847","95","50","42","aino","38000");
goods[418] =new setGoods("0000a80853","100","50","42","aino","39000");
goods[419] =new setGoods("0000a80859","105","50","42","aino","40000");
goods[420] =new setGoods("0000a80865","110","50","42","aino","41000");
goods[421] =new setGoods("0000a80871","115","50","42","aino","42000");
goods[422] =new setGoods("0000a80877","120","50","42","aino","43000");
goods[423] =new setGoods("0000a80883","125","50","42","aino","44000");
goods[424] =new setGoods("0000a80889","130","50","42","aino","45000");
goods[425] =new setGoods("0000a80895","135","50","42","aino","46000");
goods[426] =new setGoods("0000a80901","140","50","42","aino","47000");
goods[427] =new setGoods("0000a80907","145","50","42","aino","48000");
goods[428] =new setGoods("0000a80913","150","50","42","aino","49000");
goods[429] =new setGoods("0000a80919","90","55","42","aino","40000");
goods[430] =new setGoods("0000a80925","95","55","42","aino","41000");
goods[431] =new setGoods("0000a80931","100","55","42","aino","42000");
goods[432] =new setGoods("0000a80937","105","55","42","aino","43000");
goods[433] =new setGoods("0000a80943","110","55","42","aino","44000");
goods[434] =new setGoods("0000a80949","115","55","42","aino","45000");
goods[435] =new setGoods("0000a80955","120","55","42","aino","46000");
goods[436] =new setGoods("0000a80961","125","55","42","aino","47000");
goods[437] =new setGoods("0000a80967","130","55","42","aino","48000");
goods[438] =new setGoods("0000a80973","135","55","42","aino","49000");
goods[439] =new setGoods("0000a80979","140","55","42","aino","50000");
goods[440] =new setGoods("0000a80985","145","55","42","aino","51000");
goods[441] =new setGoods("0000a80991","150","55","42","aino","52000");
goods[442] =new setGoods("0000a80997","90","60","42","aino","43000");
goods[443] =new setGoods("0000a81003","95","60","42","aino","44000");
goods[444] =new setGoods("0000a81009","100","60","42","aino","45000");
goods[445] =new setGoods("0000a81015","105","60","42","aino","46000");
goods[446] =new setGoods("0000a81021","110","60","42","aino","47000");
goods[447] =new setGoods("0000a81027","115","60","42","aino","48000");
goods[448] =new setGoods("0000a81033","120","60","42","aino","49000");
goods[449] =new setGoods("0000a81039","125","60","42","aino","50000");
goods[450] =new setGoods("0000a81045","130","60","42","aino","51000");
goods[451] =new setGoods("0000a81051","135","60","42","aino","52000");
goods[452] =new setGoods("0000a81057","140","60","42","aino","53000");
goods[453] =new setGoods("0000a81063","145","60","42","aino","54000");
goods[454] =new setGoods("0000a81069","150","60","42","aino","55000");
goods[455] =new setGoods("0000a81075","90","30","50","aino","27000");
goods[456] =new setGoods("0000a81153","90","35","50","aino","30000");
goods[457] =new setGoods("0000a81231","90","40","50","aino","33000");
goods[458] =new setGoods("0000a81309","90","45","50","aino","36000");
goods[459] =new setGoods("0000a81387","90","50","50","aino","39000");
goods[460] =new setGoods("0000a81465","90","55","50","aino","42000");
goods[461] =new setGoods("0000a81543","90","60","50","aino","45000");
goods[462] =new setGoods("0000a81081","95","30","50","aino","28000");
goods[463] =new setGoods("0000a81159","95","35","50","aino","31000");
goods[464] =new setGoods("0000a81237","95","40","50","aino","34000");
goods[465] =new setGoods("0000a81315","95","45","50","aino","37000");
goods[466] =new setGoods("0000a81393","95","50","50","aino","40000");
goods[467] =new setGoods("0000a81471","95","55","50","aino","43000");
goods[468] =new setGoods("0000a81549","95","60","50","aino","46000");
goods[469] =new setGoods("0000a81087","100","30","50","aino","29000");
goods[470] =new setGoods("0000a81165","100","35","50","aino","32000");
goods[471] =new setGoods("0000a81243","100","40","50","aino","35000");
goods[472] =new setGoods("0000a81321","100","45","50","aino","38000");
goods[473] =new setGoods("0000a81399","100","50","50","aino","41000");
goods[474] =new setGoods("0000a81477","100","55","50","aino","44000");
goods[475] =new setGoods("0000a81555","100","60","50","aino","47000");
goods[476] =new setGoods("0000a81093","105","30","50","aino","30000");
goods[477] =new setGoods("0000a81171","105","35","50","aino","33000");
goods[478] =new setGoods("0000a81249","105","40","50","aino","36000");
goods[479] =new setGoods("0000a81327","105","45","50","aino","39000");
goods[480] =new setGoods("0000a81405","105","50","50","aino","42000");
goods[481] =new setGoods("0000a81483","105","55","50","aino","45000");
goods[482] =new setGoods("0000a81561","105","60","50","aino","48000");
goods[483] =new setGoods("0000a81099","110","30","50","aino","31000");
goods[484] =new setGoods("0000a81177","110","35","50","aino","34000");
goods[485] =new setGoods("0000a81255","110","40","50","aino","37000");
goods[486] =new setGoods("0000a81333","110","45","50","aino","40000");
goods[487] =new setGoods("0000a81411","110","50","50","aino","43000");
goods[488] =new setGoods("0000a81489","110","55","50","aino","46000");
goods[489] =new setGoods("0000a81567","110","60","50","aino","49000");
goods[490] =new setGoods("0000a81105","115","30","50","aino","32000");
goods[491] =new setGoods("0000a81183","115","35","50","aino","35000");
goods[492] =new setGoods("0000a81261","115","40","50","aino","38000");
goods[493] =new setGoods("0000a81339","115","45","50","aino","41000");
goods[494] =new setGoods("0000a81417","115","50","50","aino","44000");
goods[495] =new setGoods("0000a81495","115","55","50","aino","47000");
goods[496] =new setGoods("0000a81573","115","60","50","aino","50000");
goods[497] =new setGoods("0000a81111","120","30","50","aino","33000");
goods[498] =new setGoods("0000a81189","120","35","50","aino","36000");
goods[499] =new setGoods("0000a81267","120","40","50","aino","39000");
goods[500] =new setGoods("0000a81345","120","45","50","aino","42000");
goods[501] =new setGoods("0000a81423","120","50","50","aino","45000");
goods[502] =new setGoods("0000a81501","120","55","50","aino","48000");
goods[503] =new setGoods("0000a81579","120","60","50","aino","51000");
goods[504] =new setGoods("0000a81117","125","30","50","aino","34000");
goods[505] =new setGoods("0000a81195","125","35","50","aino","37000");
goods[506] =new setGoods("0000a81273","125","40","50","aino","40000");
goods[507] =new setGoods("0000a81351","125","45","50","aino","43000");
goods[508] =new setGoods("0000a81429","125","50","50","aino","46000");
goods[509] =new setGoods("0000a81507","125","55","50","aino","49000");
goods[510] =new setGoods("0000a81585","125","60","50","aino","52000");
goods[511] =new setGoods("0000a81123","130","30","50","aino","35000");
goods[512] =new setGoods("0000a81201","130","35","50","aino","38000");
goods[513] =new setGoods("0000a81279","130","40","50","aino","41000");
goods[514] =new setGoods("0000a81357","130","45","50","aino","44000");
goods[515] =new setGoods("0000a81435","130","50","50","aino","47000");
goods[516] =new setGoods("0000a81513","130","55","50","aino","50000");
goods[517] =new setGoods("0000a81591","130","60","50","aino","53000");
goods[518] =new setGoods("0000a81129","135","30","50","aino","36000");
goods[519] =new setGoods("0000a81207","135","35","50","aino","39000");
goods[520] =new setGoods("0000a81285","135","40","50","aino","42000");
goods[521] =new setGoods("0000a81363","135","45","50","aino","45000");
goods[522] =new setGoods("0000a81441","135","50","50","aino","48000");
goods[523] =new setGoods("0000a81519","135","55","50","aino","51000");
goods[524] =new setGoods("0000a81597","135","60","50","aino","54000");
goods[525] =new setGoods("0000a81135","140","30","50","aino","37000");
goods[526] =new setGoods("0000a81213","140","35","50","aino","40000");
goods[527] =new setGoods("0000a81291","140","40","50","aino","43000");
goods[528] =new setGoods("0000a81369","140","45","50","aino","46000");
goods[529] =new setGoods("0000a81447","140","50","50","aino","49000");
goods[530] =new setGoods("0000a81525","140","55","50","aino","52000");
goods[531] =new setGoods("0000a81603","140","60","50","aino","55000");
goods[532] =new setGoods("0000a81141","145","30","50","aino","38000");
goods[533] =new setGoods("0000a81219","145","35","50","aino","41000");
goods[534] =new setGoods("0000a81297","145","40","50","aino","44000");
goods[535] =new setGoods("0000a81375","145","45","50","aino","47000");
goods[536] =new setGoods("0000a81453","145","50","50","aino","50000");
goods[537] =new setGoods("0000a81531","145","55","50","aino","53000");
goods[538] =new setGoods("0000a81609","145","60","50","aino","56000");
goods[539] =new setGoods("0000a81147","150","30","50","aino","39000");
goods[540] =new setGoods("0000a81225","150","35","50","aino","42000");
goods[541] =new setGoods("0000a81303","150","40","50","aino","45000");
goods[542] =new setGoods("0000a81381","150","45","50","aino","48000");
goods[543] =new setGoods("0000a81459","150","50","50","aino","51000");
goods[544] =new setGoods("0000a81537","150","55","50","aino","54000");
goods[545] =new setGoods("0000a81615","150","60","50","aino","57000");
goods[546] =new setGoods("0000a81635","90","30","30","nail","33000");
goods[547] =new setGoods("0000a81648","90","35","30","nail","38000");
goods[548] =new setGoods("0000a81661","90","40","30","nail","43000");
goods[549] =new setGoods("0000a81674","90","45","30","nail","48000");
goods[550] =new setGoods("0000a81687","90","50","30","nail","53000");
goods[551] =new setGoods("0000a81700","90","55","30","nail","58000");
goods[552] =new setGoods("0000a81713","90","60","30","nail","63000");
goods[553] =new setGoods("0000a81636","95","30","30","nail","34000");
goods[554] =new setGoods("0000a81649","95","35","30","nail","39000");
goods[555] =new setGoods("0000a81662","95","40","30","nail","44000");
goods[556] =new setGoods("0000a81675","95","45","30","nail","49000");
goods[557] =new setGoods("0000a81688","95","50","30","nail","54000");
goods[558] =new setGoods("0000a81701","95","55","30","nail","59000");
goods[559] =new setGoods("0000a81714","95","60","30","nail","64000");
goods[560] =new setGoods("0000a81637","100","30","30","nail","35000");
goods[561] =new setGoods("0000a81650","100","35","30","nail","40000");
goods[562] =new setGoods("0000a81663","100","40","30","nail","45000");
goods[563] =new setGoods("0000a81676","100","45","30","nail","50000");
goods[564] =new setGoods("0000a81689","100","50","30","nail","55000");
goods[565] =new setGoods("0000a81702","100","55","30","nail","60000");
goods[566] =new setGoods("0000a81715","100","60","30","nail","65000");
goods[567] =new setGoods("0000a81638","105","30","30","nail","36000");
goods[568] =new setGoods("0000a81651","105","35","30","nail","41000");
goods[569] =new setGoods("0000a81664","105","40","30","nail","46000");
goods[570] =new setGoods("0000a81677","105","45","30","nail","51000");
goods[571] =new setGoods("0000a81690","105","50","30","nail","56000");
goods[572] =new setGoods("0000a81703","105","55","30","nail","61000");
goods[573] =new setGoods("0000a81716","105","60","30","nail","66000");
goods[574] =new setGoods("0000a81639","110","30","30","nail","37000");
goods[575] =new setGoods("0000a81652","110","35","30","nail","42000");
goods[576] =new setGoods("0000a81665","110","40","30","nail","47000");
goods[577] =new setGoods("0000a81678","110","45","30","nail","52000");
goods[578] =new setGoods("0000a81691","110","50","30","nail","57000");
goods[579] =new setGoods("0000a81704","110","55","30","nail","62000");
goods[580] =new setGoods("0000a81717","110","60","30","nail","67000");
goods[581] =new setGoods("0000a81640","115","30","30","nail","38000");
goods[582] =new setGoods("0000a81653","115","35","30","nail","43000");
goods[583] =new setGoods("0000a81666","115","40","30","nail","48000");
goods[584] =new setGoods("0000a81679","115","45","30","nail","53000");
goods[585] =new setGoods("0000a81692","115","50","30","nail","58000");
goods[586] =new setGoods("0000a81705","115","55","30","nail","63000");
goods[587] =new setGoods("0000a81718","115","60","30","nail","68000");
goods[588] =new setGoods("0000a81641","120","30","30","nail","39000");
goods[589] =new setGoods("0000a81654","120","35","30","nail","44000");
goods[590] =new setGoods("0000a81667","120","40","30","nail","49000");
goods[591] =new setGoods("0000a81680","120","45","30","nail","54000");
goods[592] =new setGoods("0000a81693","120","50","30","nail","59000");
goods[593] =new setGoods("0000a81706","120","55","30","nail","64000");
goods[594] =new setGoods("0000a81719","120","60","30","nail","69000");
goods[595] =new setGoods("0000a81642","125","30","30","nail","40000");
goods[596] =new setGoods("0000a81655","125","35","30","nail","45000");
goods[597] =new setGoods("0000a81668","125","40","30","nail","50000");
goods[598] =new setGoods("0000a81681","125","45","30","nail","55000");
goods[599] =new setGoods("0000a81694","125","50","30","nail","60000");
goods[600] =new setGoods("0000a81707","125","55","30","nail","65000");
goods[601] =new setGoods("0000a81720","125","60","30","nail","70000");
goods[602] =new setGoods("0000a81643","130","30","30","nail","41000");
goods[603] =new setGoods("0000a81656","130","35","30","nail","46000");
goods[604] =new setGoods("0000a81669","130","40","30","nail","51000");
goods[605] =new setGoods("0000a81682","130","45","30","nail","56000");
goods[606] =new setGoods("0000a81695","130","50","30","nail","61000");
goods[607] =new setGoods("0000a81708","130","55","30","nail","66000");
goods[608] =new setGoods("0000a81721","130","60","30","nail","71000");
goods[609] =new setGoods("0000a81644","135","30","30","nail","42000");
goods[610] =new setGoods("0000a81657","135","35","30","nail","47000");
goods[611] =new setGoods("0000a81670","135","40","30","nail","52000");
goods[612] =new setGoods("0000a81683","135","45","30","nail","57000");
goods[613] =new setGoods("0000a81696","135","50","30","nail","62000");
goods[614] =new setGoods("0000a81709","135","55","30","nail","67000");
goods[615] =new setGoods("0000a81722","135","60","30","nail","72000");
goods[616] =new setGoods("0000a81645","140","30","30","nail","43000");
goods[617] =new setGoods("0000a81658","140","35","30","nail","48000");
goods[618] =new setGoods("0000a81671","140","40","30","nail","53000");
goods[619] =new setGoods("0000a81684","140","45","30","nail","58000");
goods[620] =new setGoods("0000a81697","140","50","30","nail","63000");
goods[621] =new setGoods("0000a81710","140","55","30","nail","68000");
goods[622] =new setGoods("0000a81723","140","60","30","nail","73000");
goods[623] =new setGoods("0000a81646","145","30","30","nail","44000");
goods[624] =new setGoods("0000a81659","145","35","30","nail","49000");
goods[625] =new setGoods("0000a81672","145","40","30","nail","54000");
goods[626] =new setGoods("0000a81685","145","45","30","nail","59000");
goods[627] =new setGoods("0000a81698","145","50","30","nail","64000");
goods[628] =new setGoods("0000a81711","145","55","30","nail","69000");
goods[629] =new setGoods("0000a81724","145","60","30","nail","74000");
goods[630] =new setGoods("0000a81647","150","30","30","nail","45000");
goods[631] =new setGoods("0000a81660","150","35","30","nail","50000");
goods[632] =new setGoods("0000a81673","150","40","30","nail","55000");
goods[633] =new setGoods("0000a81686","150","45","30","nail","60000");
goods[634] =new setGoods("0000a81699","150","50","30","nail","65000");
goods[635] =new setGoods("0000a81712","150","55","30","nail","70000");
goods[636] =new setGoods("0000a81725","150","60","30","nail","75000");
goods[637] =new setGoods("0000a81726","90","30","42","nail","38000");
goods[638] =new setGoods("0000a81727","95","30","42","nail","39000");
goods[639] =new setGoods("0000a81728","100","30","42","nail","40000");
goods[640] =new setGoods("0000a81729","105","30","42","nail","41000");
goods[641] =new setGoods("0000a81730","110","30","42","nail","42000");
goods[642] =new setGoods("0000a81731","115","30","42","nail","43000");
goods[643] =new setGoods("0000a81732","120","30","42","nail","44000");
goods[644] =new setGoods("0000a81733","125","30","42","nail","45000");
goods[645] =new setGoods("0000a81734","130","30","42","nail","46000");
goods[646] =new setGoods("0000a81735","135","30","42","nail","47000");
goods[647] =new setGoods("0000a81736","140","30","42","nail","48000");
goods[648] =new setGoods("0000a81737","145","30","42","nail","49000");
goods[649] =new setGoods("0000a81738","150","30","42","nail","50000");
goods[650] =new setGoods("0000a81739","90","35","42","nail","43000");
goods[651] =new setGoods("0000a81740","95","35","42","nail","44000");
goods[652] =new setGoods("0000a81741","100","35","42","nail","45000");
goods[653] =new setGoods("0000a81742","105","35","42","nail","46000");
goods[654] =new setGoods("0000a81743","110","35","42","nail","47000");
goods[655] =new setGoods("0000a81744","115","35","42","nail","48000");
goods[656] =new setGoods("0000a81745","120","35","42","nail","49000");
goods[657] =new setGoods("0000a81746","125","35","42","nail","50000");
goods[658] =new setGoods("0000a81747","130","35","42","nail","51000");
goods[659] =new setGoods("0000a81748","135","35","42","nail","52000");
goods[660] =new setGoods("0000a81749","140","35","42","nail","53000");
goods[661] =new setGoods("0000a81750","145","35","42","nail","54000");
goods[662] =new setGoods("0000a81751","150","35","42","nail","55000");
goods[663] =new setGoods("0000a81752","90","40","42","nail","48000");
goods[664] =new setGoods("0000a81753","95","40","42","nail","49000");
goods[665] =new setGoods("0000a81754","100","40","42","nail","50000");
goods[666] =new setGoods("0000a81755","105","40","42","nail","51000");
goods[667] =new setGoods("0000a81756","110","40","42","nail","52000");
goods[668] =new setGoods("0000a81757","115","40","42","nail","53000");
goods[669] =new setGoods("0000a81758","120","40","42","nail","54000");
goods[670] =new setGoods("0000a81759","125","40","42","nail","55000");
goods[671] =new setGoods("0000a81760","130","40","42","nail","56000");
goods[672] =new setGoods("0000a81761","135","40","42","nail","57000");
goods[673] =new setGoods("0000a81762","140","40","42","nail","58000");
goods[674] =new setGoods("0000a81763","145","40","42","nail","59000");
goods[675] =new setGoods("0000a81764","150","40","42","nail","60000");
goods[676] =new setGoods("0000a81765","90","45","42","nail","53000");
goods[677] =new setGoods("0000a81766","95","45","42","nail","54000");
goods[678] =new setGoods("0000a81767","100","45","42","nail","55000");
goods[679] =new setGoods("0000a81768","105","45","42","nail","56000");
goods[680] =new setGoods("0000a81769","110","45","42","nail","57000");
goods[681] =new setGoods("0000a81770","115","45","42","nail","58000");
goods[682] =new setGoods("0000a81771","120","45","42","nail","59000");
goods[683] =new setGoods("0000a81772","125","45","42","nail","60000");
goods[684] =new setGoods("0000a81773","130","45","42","nail","61000");
goods[685] =new setGoods("0000a81774","135","45","42","nail","62000");
goods[686] =new setGoods("0000a81775","140","45","42","nail","63000");
goods[687] =new setGoods("0000a81776","145","45","42","nail","64000");
goods[688] =new setGoods("0000a81777","150","45","42","nail","65000");
goods[689] =new setGoods("0000a81778","90","50","42","nail","58000");
goods[690] =new setGoods("0000a81779","95","50","42","nail","59000");
goods[691] =new setGoods("0000a81780","100","50","42","nail","60000");
goods[692] =new setGoods("0000a81781","105","50","42","nail","61000");
goods[693] =new setGoods("0000a81782","110","50","42","nail","62000");
goods[694] =new setGoods("0000a81783","115","50","42","nail","63000");
goods[695] =new setGoods("0000a81784","120","50","42","nail","64000");
goods[696] =new setGoods("0000a81785","125","50","42","nail","65000");
goods[697] =new setGoods("0000a81786","130","50","42","nail","66000");
goods[698] =new setGoods("0000a81787","135","50","42","nail","67000");
goods[699] =new setGoods("0000a81788","140","50","42","nail","68000");
goods[700] =new setGoods("0000a81789","145","50","42","nail","69000");
goods[701] =new setGoods("0000a81790","150","50","42","nail","70000");
goods[702] =new setGoods("0000a81791","90","55","42","nail","63000");
goods[703] =new setGoods("0000a81792","95","55","42","nail","64000");
goods[704] =new setGoods("0000a81793","100","55","42","nail","65000");
goods[705] =new setGoods("0000a81794","105","55","42","nail","66000");
goods[706] =new setGoods("0000a09426","110","55","42","nail","67000");
goods[707] =new setGoods("0000a81795","115","55","42","nail","68000");
goods[708] =new setGoods("0000a81796","120","55","42","nail","69000");
goods[709] =new setGoods("0000a81797","125","55","42","nail","70000");
goods[710] =new setGoods("0000a81798","130","55","42","nail","71000");
goods[711] =new setGoods("0000a81799","135","55","42","nail","72000");
goods[712] =new setGoods("0000a81800","140","55","42","nail","73000");
goods[713] =new setGoods("0000a81801","145","55","42","nail","74000");
goods[714] =new setGoods("0000a81802","150","55","42","nail","75000");
goods[715] =new setGoods("0000a81803","90","60","42","nail","68000");
goods[716] =new setGoods("0000a81804","95","60","42","nail","69000");
goods[717] =new setGoods("0000a81805","100","60","42","nail","70000");
goods[718] =new setGoods("0000a81806","105","60","42","nail","71000");
goods[719] =new setGoods("0000a81807","110","60","42","nail","72000");
goods[720] =new setGoods("0000a81808","115","60","42","nail","73000");
goods[721] =new setGoods("0000a81809","120","60","42","nail","74000");
goods[722] =new setGoods("0000a81810","125","60","42","nail","75000");
goods[723] =new setGoods("0000a81811","130","60","42","nail","76000");
goods[724] =new setGoods("0000a81812","135","60","42","nail","77000");
goods[725] =new setGoods("0000a81813","140","60","42","nail","78000");
goods[726] =new setGoods("0000a81814","145","60","42","nail","79000");
goods[727] =new setGoods("0000a81815","150","60","42","nail","80000");
goods[728] =new setGoods("0000a81816","90","30","50","nail","43000");
goods[729] =new setGoods("0000a81829","90","35","50","nail","48000");
goods[730] =new setGoods("0000a81842","90","40","50","nail","53000");
goods[731] =new setGoods("0000a81855","90","45","50","nail","58000");
goods[732] =new setGoods("0000a81868","90","50","50","nail","63000");
goods[733] =new setGoods("0000a81881","90","55","50","nail","68000");
goods[734] =new setGoods("0000a81894","90","60","50","nail","73000");
goods[735] =new setGoods("0000a81817","95","30","50","nail","44000");
goods[736] =new setGoods("0000a81830","95","35","50","nail","49000");
goods[737] =new setGoods("0000a81843","95","40","50","nail","54000");
goods[738] =new setGoods("0000a81856","95","45","50","nail","59000");
goods[739] =new setGoods("0000a81869","95","50","50","nail","64000");
goods[740] =new setGoods("0000a81882","95","55","50","nail","69000");
goods[741] =new setGoods("0000a81895","95","60","50","nail","74000");
goods[742] =new setGoods("0000a81818","100","30","50","nail","45000");
goods[743] =new setGoods("0000a81831","100","35","50","nail","50000");
goods[744] =new setGoods("0000a81844","100","40","50","nail","55000");
goods[745] =new setGoods("0000a81857","100","45","50","nail","60000");
goods[746] =new setGoods("0000a81870","100","50","50","nail","65000");
goods[747] =new setGoods("0000a81883","100","55","50","nail","70000");
goods[748] =new setGoods("0000a81896","100","60","50","nail","75000");
goods[749] =new setGoods("0000a81819","105","30","50","nail","46000");
goods[750] =new setGoods("0000a81832","105","35","50","nail","51000");
goods[751] =new setGoods("0000a81845","105","40","50","nail","56000");
goods[752] =new setGoods("0000a81858","105","45","50","nail","61000");
goods[753] =new setGoods("0000a81871","105","50","50","nail","66000");
goods[754] =new setGoods("0000a81884","105","55","50","nail","71000");
goods[755] =new setGoods("0000a81897","105","60","50","nail","76000");
goods[756] =new setGoods("0000a81820","110","30","50","nail","47000");
goods[757] =new setGoods("0000a81833","110","35","50","nail","52000");
goods[758] =new setGoods("0000a81846","110","40","50","nail","57000");
goods[759] =new setGoods("0000a81859","110","45","50","nail","62000");
goods[760] =new setGoods("0000a81872","110","50","50","nail","67000");
goods[761] =new setGoods("0000a81885","110","55","50","nail","72000");
goods[762] =new setGoods("0000a81898","110","60","50","nail","77000");
goods[763] =new setGoods("0000a81821","115","30","50","nail","48000");
goods[764] =new setGoods("0000a81834","115","35","50","nail","53000");
goods[765] =new setGoods("0000a81847","115","40","50","nail","58000");
goods[766] =new setGoods("0000a81860","115","45","50","nail","63000");
goods[767] =new setGoods("0000a81873","115","50","50","nail","68000");
goods[768] =new setGoods("0000a81886","115","55","50","nail","73000");
goods[769] =new setGoods("0000a81899","115","60","50","nail","78000");
goods[770] =new setGoods("0000a81822","120","30","50","nail","49000");
goods[771] =new setGoods("0000a81835","120","35","50","nail","54000");
goods[772] =new setGoods("0000a81848","120","40","50","nail","59000");
goods[773] =new setGoods("0000a81861","120","45","50","nail","64000");
goods[774] =new setGoods("0000a81874","120","50","50","nail","69000");
goods[775] =new setGoods("0000a81887","120","55","50","nail","74000");
goods[776] =new setGoods("0000a81900","120","60","50","nail","79000");
goods[777] =new setGoods("0000a81823","125","30","50","nail","50000");
goods[778] =new setGoods("0000a81836","125","35","50","nail","55000");
goods[779] =new setGoods("0000a81849","125","40","50","nail","60000");
goods[780] =new setGoods("0000a81862","125","45","50","nail","65000");
goods[781] =new setGoods("0000a81875","125","50","50","nail","70000");
goods[782] =new setGoods("0000a81888","125","55","50","nail","75000");
goods[783] =new setGoods("0000a81901","125","60","50","nail","80000");
goods[784] =new setGoods("0000a81824","130","30","50","nail","51000");
goods[785] =new setGoods("0000a81837","130","35","50","nail","56000");
goods[786] =new setGoods("0000a81850","130","40","50","nail","61000");
goods[787] =new setGoods("0000a81863","130","45","50","nail","66000");
goods[788] =new setGoods("0000a81876","130","50","50","nail","71000");
goods[789] =new setGoods("0000a81889","130","55","50","nail","76000");
goods[790] =new setGoods("0000a81902","130","60","50","nail","81000");
goods[791] =new setGoods("0000a81825","135","30","50","nail","52000");
goods[792] =new setGoods("0000a81838","135","35","50","nail","57000");
goods[793] =new setGoods("0000a81851","135","40","50","nail","62000");
goods[794] =new setGoods("0000a81864","135","45","50","nail","67000");
goods[795] =new setGoods("0000a81877","135","50","50","nail","72000");
goods[796] =new setGoods("0000a81890","135","55","50","nail","77000");
goods[797] =new setGoods("0000a81903","135","60","50","nail","82000");
goods[798] =new setGoods("0000a81826","140","30","50","nail","53000");
goods[799] =new setGoods("0000a81839","140","35","50","nail","58000");
goods[800] =new setGoods("0000a81852","140","40","50","nail","63000");
goods[801] =new setGoods("0000a81865","140","45","50","nail","68000");
goods[802] =new setGoods("0000a81878","140","50","50","nail","73000");
goods[803] =new setGoods("0000a81891","140","55","50","nail","78000");
goods[804] =new setGoods("0000a81904","140","60","50","nail","83000");
goods[805] =new setGoods("0000a81827","145","30","50","nail","54000");
goods[806] =new setGoods("0000a81840","145","35","50","nail","59000");
goods[807] =new setGoods("0000a81853","145","40","50","nail","64000");
goods[808] =new setGoods("0000a81866","145","45","50","nail","69000");
goods[809] =new setGoods("0000a81879","145","50","50","nail","74000");
goods[810] =new setGoods("0000a81892","145","55","50","nail","79000");
goods[811] =new setGoods("0000a81905","145","60","50","nail","84000");
goods[812] =new setGoods("0000a81828","150","30","50","nail","55000");
goods[813] =new setGoods("0000a81841","150","35","50","nail","60000");
goods[814] =new setGoods("0000a81854","150","40","50","nail","65000");
goods[815] =new setGoods("0000a81867","150","45","50","nail","70000");
goods[816] =new setGoods("0000a81880","150","50","50","nail","75000");
goods[817] =new setGoods("0000a81893","150","55","50","nail","80000");
goods[818] =new setGoods("0000a81906","150","60","50","nail","85000");
goods[819] =new setGoods("0000a81907","90","30","30","black","33000");
goods[820] =new setGoods("0000a81920","90","35","30","black","38000");
goods[821] =new setGoods("0000a81933","90","40","30","black","43000");
goods[822] =new setGoods("0000a81946","90","45","30","black","48000");
goods[823] =new setGoods("0000a81959","90","50","30","black","53000");
goods[824] =new setGoods("0000a81972","90","55","30","black","58000");
goods[825] =new setGoods("0000a81985","90","60","30","black","63000");
goods[826] =new setGoods("0000a81908","95","30","30","black","34000");
goods[827] =new setGoods("0000a81921","95","35","30","black","39000");
goods[828] =new setGoods("0000a81934","95","40","30","black","44000");
goods[829] =new setGoods("0000a81947","95","45","30","black","49000");
goods[830] =new setGoods("0000a81960","95","50","30","black","54000");
goods[831] =new setGoods("0000a81973","95","55","30","black","59000");
goods[832] =new setGoods("0000a81986","95","60","30","black","64000");
goods[833] =new setGoods("0000a81909","100","30","30","black","35000");
goods[834] =new setGoods("0000a81922","100","35","30","black","40000");
goods[835] =new setGoods("0000a81935","100","40","30","black","45000");
goods[836] =new setGoods("0000a81948","100","45","30","black","50000");
goods[837] =new setGoods("0000a81961","100","50","30","black","55000");
goods[838] =new setGoods("0000a81974","100","55","30","black","60000");
goods[839] =new setGoods("0000a81987","100","60","30","black","65000");
goods[840] =new setGoods("0000a81910","105","30","30","black","36000");
goods[841] =new setGoods("0000a81923","105","35","30","black","41000");
goods[842] =new setGoods("0000a81936","105","40","30","black","46000");
goods[843] =new setGoods("0000a81949","105","45","30","black","51000");
goods[844] =new setGoods("0000a81962","105","50","30","black","56000");
goods[845] =new setGoods("0000a81975","105","55","30","black","61000");
goods[846] =new setGoods("0000a81988","105","60","30","black","66000");
goods[847] =new setGoods("0000a81911","110","30","30","black","37000");
goods[848] =new setGoods("0000a81924","110","35","30","black","42000");
goods[849] =new setGoods("0000a81937","110","40","30","black","47000");
goods[850] =new setGoods("0000a81950","110","45","30","black","52000");
goods[851] =new setGoods("0000a81963","110","50","30","black","57000");
goods[852] =new setGoods("0000a81976","110","55","30","black","62000");
goods[853] =new setGoods("0000a81989","110","60","30","black","67000");
goods[854] =new setGoods("0000a81912","115","30","30","black","38000");
goods[855] =new setGoods("0000a81925","115","35","30","black","43000");
goods[856] =new setGoods("0000a81938","115","40","30","black","48000");
goods[857] =new setGoods("0000a81951","115","45","30","black","53000");
goods[858] =new setGoods("0000a81964","115","50","30","black","58000");
goods[859] =new setGoods("0000a81977","115","55","30","black","63000");
goods[860] =new setGoods("0000a81990","115","60","30","black","68000");
goods[861] =new setGoods("0000a81913","120","30","30","black","39000");
goods[862] =new setGoods("0000a81926","120","35","30","black","44000");
goods[863] =new setGoods("0000a81939","120","40","30","black","49000");
goods[864] =new setGoods("0000a81952","120","45","30","black","54000");
goods[865] =new setGoods("0000a81965","120","50","30","black","59000");
goods[866] =new setGoods("0000a81978","120","55","30","black","64000");
goods[867] =new setGoods("0000a81991","120","60","30","black","69000");
goods[868] =new setGoods("0000a81914","125","30","30","black","40000");
goods[869] =new setGoods("0000a81927","125","35","30","black","45000");
goods[870] =new setGoods("0000a81940","125","40","30","black","50000");
goods[871] =new setGoods("0000a81953","125","45","30","black","55000");
goods[872] =new setGoods("0000a81966","125","50","30","black","60000");
goods[873] =new setGoods("0000a81979","125","55","30","black","65000");
goods[874] =new setGoods("0000a81992","125","60","30","black","70000");
goods[875] =new setGoods("0000a81915","130","30","30","black","41000");
goods[876] =new setGoods("0000a81928","130","35","30","black","46000");
goods[877] =new setGoods("0000a81941","130","40","30","black","51000");
goods[878] =new setGoods("0000a81954","130","45","30","black","56000");
goods[879] =new setGoods("0000a81967","130","50","30","black","61000");
goods[880] =new setGoods("0000a81980","130","55","30","black","66000");
goods[881] =new setGoods("0000a81993","130","60","30","black","71000");
goods[882] =new setGoods("0000a81916","135","30","30","black","42000");
goods[883] =new setGoods("0000a81929","135","35","30","black","47000");
goods[884] =new setGoods("0000a81942","135","40","30","black","52000");
goods[885] =new setGoods("0000a81955","135","45","30","black","57000");
goods[886] =new setGoods("0000a81968","135","50","30","black","62000");
goods[887] =new setGoods("0000a81981","135","55","30","black","67000");
goods[888] =new setGoods("0000a81994","135","60","30","black","72000");
goods[889] =new setGoods("0000a81917","140","30","30","black","43000");
goods[890] =new setGoods("0000a81930","140","35","30","black","48000");
goods[891] =new setGoods("0000a81943","140","40","30","black","53000");
goods[892] =new setGoods("0000a81956","140","45","30","black","58000");
goods[893] =new setGoods("0000a81969","140","50","30","black","63000");
goods[894] =new setGoods("0000a81982","140","55","30","black","68000");
goods[895] =new setGoods("0000a81995","140","60","30","black","73000");
goods[896] =new setGoods("0000a81918","145","30","30","black","44000");
goods[897] =new setGoods("0000a81931","145","35","30","black","49000");
goods[898] =new setGoods("0000a81944","145","40","30","black","54000");
goods[899] =new setGoods("0000a81957","145","45","30","black","59000");
goods[900] =new setGoods("0000a81970","145","50","30","black","64000");
goods[901] =new setGoods("0000a81983","145","55","30","black","69000");
goods[902] =new setGoods("0000a81996","145","60","30","black","74000");
goods[903] =new setGoods("0000a81919","150","30","30","black","45000");
goods[904] =new setGoods("0000a81932","150","35","30","black","50000");
goods[905] =new setGoods("0000a81945","150","40","30","black","55000");
goods[906] =new setGoods("0000a81958","150","45","30","black","60000");
goods[907] =new setGoods("0000a81971","150","50","30","black","65000");
goods[908] =new setGoods("0000a81984","150","55","30","black","70000");
goods[909] =new setGoods("0000a81997","150","60","30","black","75000");
goods[910] =new setGoods("0000a81998","90","30","42","black","38000");
goods[911] =new setGoods("0000a81999","95","30","42","black","39000");
goods[912] =new setGoods("0000a82000","100","30","42","black","40000");
goods[913] =new setGoods("0000a82001","105","30","42","black","41000");
goods[914] =new setGoods("0000a82002","110","30","42","black","42000");
goods[915] =new setGoods("0000a82003","115","30","42","black","43000");
goods[916] =new setGoods("0000a82004","120","30","42","black","44000");
goods[917] =new setGoods("0000a82005","125","30","42","black","45000");
goods[918] =new setGoods("0000a82006","130","30","42","black","46000");
goods[919] =new setGoods("0000a82007","135","30","42","black","47000");
goods[920] =new setGoods("0000a82008","140","30","42","black","48000");
goods[921] =new setGoods("0000a82009","145","30","42","black","49000");
goods[922] =new setGoods("0000a82010","150","30","42","black","50000");
goods[923] =new setGoods("0000a82011","90","35","42","black","43000");
goods[924] =new setGoods("0000a82012","95","35","42","black","44000");
goods[925] =new setGoods("0000a82013","100","35","42","black","45000");
goods[926] =new setGoods("0000a82014","105","35","42","black","46000");
goods[927] =new setGoods("0000a82015","110","35","42","black","47000");
goods[928] =new setGoods("0000a82016","115","35","42","black","48000");
goods[929] =new setGoods("0000a82017","120","35","42","black","49000");
goods[930] =new setGoods("0000a82018","125","35","42","black","50000");
goods[931] =new setGoods("0000a82019","130","35","42","black","51000");
goods[932] =new setGoods("0000a82020","135","35","42","black","52000");
goods[933] =new setGoods("0000a82021","140","35","42","black","53000");
goods[934] =new setGoods("0000a82022","145","35","42","black","54000");
goods[935] =new setGoods("0000a82023","150","35","42","black","55000");
goods[936] =new setGoods("0000a82024","90","40","42","black","48000");
goods[937] =new setGoods("0000a82025","95","40","42","black","49000");
goods[938] =new setGoods("0000a82026","100","40","42","black","50000");
goods[939] =new setGoods("0000a82027","105","40","42","black","51000");
goods[940] =new setGoods("0000a82028","110","40","42","black","52000");
goods[941] =new setGoods("0000a82029","115","40","42","black","53000");
goods[942] =new setGoods("0000a82030","120","40","42","black","54000");
goods[943] =new setGoods("0000a82031","125","40","42","black","55000");
goods[944] =new setGoods("0000a82032","130","40","42","black","56000");
goods[945] =new setGoods("0000a82033","135","40","42","black","57000");
goods[946] =new setGoods("0000a82034","140","40","42","black","58000");
goods[947] =new setGoods("0000a82035","145","40","42","black","59000");
goods[948] =new setGoods("0000a82036","150","40","42","black","60000");
goods[949] =new setGoods("0000a82037","90","45","42","black","53000");
goods[950] =new setGoods("0000a82038","95","45","42","black","54000");
goods[951] =new setGoods("0000a82039","100","45","42","black","55000");
goods[952] =new setGoods("0000a82040","105","45","42","black","56000");
goods[953] =new setGoods("0000a82041","110","45","42","black","57000");
goods[954] =new setGoods("0000a82042","115","45","42","black","58000");
goods[955] =new setGoods("0000a82043","120","45","42","black","59000");
goods[956] =new setGoods("0000a82044","125","45","42","black","60000");
goods[957] =new setGoods("0000a82045","130","45","42","black","61000");
goods[958] =new setGoods("0000a82046","135","45","42","black","62000");
goods[959] =new setGoods("0000a82047","140","45","42","black","63000");
goods[960] =new setGoods("0000a82048","145","45","42","black","64000");
goods[961] =new setGoods("0000a82049","150","45","42","black","65000");
goods[962] =new setGoods("0000a82050","90","50","42","black","58000");
goods[963] =new setGoods("0000a82051","95","50","42","black","59000");
goods[964] =new setGoods("0000a82052","100","50","42","black","60000");
goods[965] =new setGoods("0000a82053","105","50","42","black","61000");
goods[966] =new setGoods("0000a82054","110","50","42","black","62000");
goods[967] =new setGoods("0000a82055","115","50","42","black","63000");
goods[968] =new setGoods("0000a82056","120","50","42","black","64000");
goods[969] =new setGoods("0000a82057","125","50","42","black","65000");
goods[970] =new setGoods("0000a82058","130","50","42","black","66000");
goods[971] =new setGoods("0000a82059","135","50","42","black","67000");
goods[972] =new setGoods("0000a82060","140","50","42","black","68000");
goods[973] =new setGoods("0000a82061","145","50","42","black","69000");
goods[974] =new setGoods("0000a82062","150","50","42","black","70000");
goods[975] =new setGoods("0000a82063","90","55","42","black","63000");
goods[976] =new setGoods("0000a82064","95","55","42","black","64000");
goods[977] =new setGoods("0000a82065","100","55","42","black","65000");
goods[978] =new setGoods("0000a82066","105","55","42","black","66000");
goods[979] =new setGoods("0000a50561","110","55","42","black","67000");
goods[980] =new setGoods("0000a82067","115","55","42","black","68000");
goods[981] =new setGoods("0000a82068","120","55","42","black","69000");
goods[982] =new setGoods("0000a82069","125","55","42","black","70000");
goods[983] =new setGoods("0000a82070","130","55","42","black","71000");
goods[984] =new setGoods("0000a82071","135","55","42","black","72000");
goods[985] =new setGoods("0000a82072","140","55","42","black","73000");
goods[986] =new setGoods("0000a82073","145","55","42","black","74000");
goods[987] =new setGoods("0000a82074","150","55","42","black","75000");
goods[988] =new setGoods("0000a82075","90","60","42","black","68000");
goods[989] =new setGoods("0000a82076","95","60","42","black","69000");
goods[990] =new setGoods("0000a82077","100","60","42","black","70000");
goods[991] =new setGoods("0000a82078","105","60","42","black","71000");
goods[992] =new setGoods("0000a82079","110","60","42","black","72000");
goods[993] =new setGoods("0000a82080","115","60","42","black","73000");
goods[994] =new setGoods("0000a82081","120","60","42","black","74000");
goods[995] =new setGoods("0000a82082","125","60","42","black","75000");
goods[996] =new setGoods("0000a82083","130","60","42","black","76000");
goods[997] =new setGoods("0000a82084","135","60","42","black","77000");
goods[998] =new setGoods("0000a82085","140","60","42","black","78000");
goods[999] =new setGoods("0000a82086","145","60","42","black","79000");
goods[1000] =new setGoods("0000a82087","150","60","42","black","80000");
goods[1001] =new setGoods("0000a82088","90","30","50","black","43000");
goods[1002] =new setGoods("0000a82101","90","35","50","black","48000");
goods[1003] =new setGoods("0000a82114","90","40","50","black","53000");
goods[1004] =new setGoods("0000a82127","90","45","50","black","58000");
goods[1005] =new setGoods("0000a82140","90","50","50","black","63000");
goods[1006] =new setGoods("0000a82153","90","55","50","black","68000");
goods[1007] =new setGoods("0000a82166","90","60","50","black","73000");
goods[1008] =new setGoods("0000a82089","95","30","50","black","44000");
goods[1009] =new setGoods("0000a82102","95","35","50","black","49000");
goods[1010] =new setGoods("0000a82115","95","40","50","black","54000");
goods[1011] =new setGoods("0000a82128","95","45","50","black","59000");
goods[1012] =new setGoods("0000a82141","95","50","50","black","64000");
goods[1013] =new setGoods("0000a82154","95","55","50","black","69000");
goods[1014] =new setGoods("0000a82167","95","60","50","black","74000");
goods[1015] =new setGoods("0000a82090","100","30","50","black","45000");
goods[1016] =new setGoods("0000a82103","100","35","50","black","50000");
goods[1017] =new setGoods("0000a82116","100","40","50","black","55000");
goods[1018] =new setGoods("0000a82129","100","45","50","black","60000");
goods[1019] =new setGoods("0000a82142","100","50","50","black","65000");
goods[1020] =new setGoods("0000a82155","100","55","50","black","70000");
goods[1021] =new setGoods("0000a82168","100","60","50","black","75000");
goods[1022] =new setGoods("0000a82091","105","30","50","black","46000");
goods[1023] =new setGoods("0000a82104","105","35","50","black","51000");
goods[1024] =new setGoods("0000a82117","105","40","50","black","56000");
goods[1025] =new setGoods("0000a82130","105","45","50","black","61000");
goods[1026] =new setGoods("0000a82143","105","50","50","black","66000");
goods[1027] =new setGoods("0000a82156","105","55","50","black","71000");
goods[1028] =new setGoods("0000a82169","105","60","50","black","76000");
goods[1029] =new setGoods("0000a82092","110","30","50","black","47000");
goods[1030] =new setGoods("0000a82105","110","35","50","black","52000");
goods[1031] =new setGoods("0000a82118","110","40","50","black","57000");
goods[1032] =new setGoods("0000a82131","110","45","50","black","62000");
goods[1033] =new setGoods("0000a82144","110","50","50","black","67000");
goods[1034] =new setGoods("0000a82157","110","55","50","black","72000");
goods[1035] =new setGoods("0000a82170","110","60","50","black","77000");
goods[1036] =new setGoods("0000a82093","115","30","50","black","48000");
goods[1037] =new setGoods("0000a82106","115","35","50","black","53000");
goods[1038] =new setGoods("0000a82119","115","40","50","black","58000");
goods[1039] =new setGoods("0000a82132","115","45","50","black","63000");
goods[1040] =new setGoods("0000a82145","115","50","50","black","68000");
goods[1041] =new setGoods("0000a82158","115","55","50","black","73000");
goods[1042] =new setGoods("0000a82171","115","60","50","black","78000");
goods[1043] =new setGoods("0000a82094","120","30","50","black","49000");
goods[1044] =new setGoods("0000a82107","120","35","50","black","54000");
goods[1045] =new setGoods("0000a82120","120","40","50","black","59000");
goods[1046] =new setGoods("0000a82133","120","45","50","black","64000");
goods[1047] =new setGoods("0000a82146","120","50","50","black","69000");
goods[1048] =new setGoods("0000a82159","120","55","50","black","74000");
goods[1049] =new setGoods("0000a82172","120","60","50","black","79000");
goods[1050] =new setGoods("0000a82095","125","30","50","black","50000");
goods[1051] =new setGoods("0000a82108","125","35","50","black","55000");
goods[1052] =new setGoods("0000a82121","125","40","50","black","60000");
goods[1053] =new setGoods("0000a82134","125","45","50","black","65000");
goods[1054] =new setGoods("0000a82147","125","50","50","black","70000");
goods[1055] =new setGoods("0000a82160","125","55","50","black","75000");
goods[1056] =new setGoods("0000a82173","125","60","50","black","80000");
goods[1057] =new setGoods("0000a82096","130","30","50","black","51000");
goods[1058] =new setGoods("0000a82109","130","35","50","black","56000");
goods[1059] =new setGoods("0000a82122","130","40","50","black","61000");
goods[1060] =new setGoods("0000a82135","130","45","50","black","66000");
goods[1061] =new setGoods("0000a82148","130","50","50","black","71000");
goods[1062] =new setGoods("0000a82161","130","55","50","black","76000");
goods[1063] =new setGoods("0000a82174","130","60","50","black","81000");
goods[1064] =new setGoods("0000a82097","135","30","50","black","52000");
goods[1065] =new setGoods("0000a82110","135","35","50","black","57000");
goods[1066] =new setGoods("0000a82123","135","40","50","black","62000");
goods[1067] =new setGoods("0000a82136","135","45","50","black","67000");
goods[1068] =new setGoods("0000a82149","135","50","50","black","72000");
goods[1069] =new setGoods("0000a82162","135","55","50","black","77000");
goods[1070] =new setGoods("0000a82175","135","60","50","black","82000");
goods[1071] =new setGoods("0000a82098","140","30","50","black","53000");
goods[1072] =new setGoods("0000a82111","140","35","50","black","58000");
goods[1073] =new setGoods("0000a82124","140","40","50","black","63000");
goods[1074] =new setGoods("0000a82137","140","45","50","black","68000");
goods[1075] =new setGoods("0000a82150","140","50","50","black","73000");
goods[1076] =new setGoods("0000a82163","140","55","50","black","78000");
goods[1077] =new setGoods("0000a82176","140","60","50","black","83000");
goods[1078] =new setGoods("0000a82099","145","30","50","black","54000");
goods[1079] =new setGoods("0000a82112","145","35","50","black","59000");
goods[1080] =new setGoods("0000a82125","145","40","50","black","64000");
goods[1081] =new setGoods("0000a82138","145","45","50","black","69000");
goods[1082] =new setGoods("0000a82151","145","50","50","black","74000");
goods[1083] =new setGoods("0000a82164","145","55","50","black","79000");
goods[1084] =new setGoods("0000a82177","145","60","50","black","84000");
goods[1085] =new setGoods("0000a82100","150","30","50","black","55000");
goods[1086] =new setGoods("0000a82113","150","35","50","black","60000");
goods[1087] =new setGoods("0000a82126","150","40","50","black","65000");
goods[1088] =new setGoods("0000a82139","150","45","50","black","70000");
goods[1089] =new setGoods("0000a82152","150","50","50","black","75000");
goods[1090] =new setGoods("0000a82165","150","55","50","black","80000");
goods[1091] =new setGoods("0000a82178","150","60","50","black","85000");
goods[1092] =new setGoods("0000a82179","90","30","30","bp","38000");
goods[1093] =new setGoods("0000a82192","90","35","30","bp","43000");
goods[1094] =new setGoods("0000a82205","90","40","30","bp","48000");
goods[1095] =new setGoods("0000a82218","90","45","30","bp","53000");
goods[1096] =new setGoods("0000a82231","90","50","30","bp","58000");
goods[1097] =new setGoods("0000a82244","90","55","30","bp","63000");
goods[1098] =new setGoods("0000a82257","90","60","30","bp","68000");
goods[1099] =new setGoods("0000a82180","95","30","30","bp","39000");
goods[1100] =new setGoods("0000a82193","95","35","30","bp","44000");
goods[1101] =new setGoods("0000a82206","95","40","30","bp","49000");
goods[1102] =new setGoods("0000a82219","95","45","30","bp","54000");
goods[1103] =new setGoods("0000a82232","95","50","30","bp","59000");
goods[1104] =new setGoods("0000a82245","95","55","30","bp","64000");
goods[1105] =new setGoods("0000a82258","95","60","30","bp","69000");
goods[1106] =new setGoods("0000a82181","100","30","30","bp","40000");
goods[1107] =new setGoods("0000a82194","100","35","30","bp","45000");
goods[1108] =new setGoods("0000a82207","100","40","30","bp","50000");
goods[1109] =new setGoods("0000a82220","100","45","30","bp","55000");
goods[1110] =new setGoods("0000a82233","100","50","30","bp","60000");
goods[1111] =new setGoods("0000a82246","100","55","30","bp","65000");
goods[1112] =new setGoods("0000a82259","100","60","30","bp","70000");
goods[1113] =new setGoods("0000a82182","105","30","30","bp","41000");
goods[1114] =new setGoods("0000a82195","105","35","30","bp","46000");
goods[1115] =new setGoods("0000a82208","105","40","30","bp","51000");
goods[1116] =new setGoods("0000a82221","105","45","30","bp","56000");
goods[1117] =new setGoods("0000a82234","105","50","30","bp","61000");
goods[1118] =new setGoods("0000a82247","105","55","30","bp","66000");
goods[1119] =new setGoods("0000a82260","105","60","30","bp","71000");
goods[1120] =new setGoods("0000a82183","110","30","30","bp","42000");
goods[1121] =new setGoods("0000a82196","110","35","30","bp","47000");
goods[1122] =new setGoods("0000a82209","110","40","30","bp","52000");
goods[1123] =new setGoods("0000a82222","110","45","30","bp","57000");
goods[1124] =new setGoods("0000a82235","110","50","30","bp","62000");
goods[1125] =new setGoods("0000a82248","110","55","30","bp","67000");
goods[1126] =new setGoods("0000a82261","110","60","30","bp","72000");
goods[1127] =new setGoods("0000a82184","115","30","30","bp","43000");
goods[1128] =new setGoods("0000a82197","115","35","30","bp","48000");
goods[1129] =new setGoods("0000a82210","115","40","30","bp","53000");
goods[1130] =new setGoods("0000a82223","115","45","30","bp","58000");
goods[1131] =new setGoods("0000a82236","115","50","30","bp","63000");
goods[1132] =new setGoods("0000a82249","115","55","30","bp","68000");
goods[1133] =new setGoods("0000a82262","115","60","30","bp","73000");
goods[1134] =new setGoods("0000a82185","120","30","30","bp","44000");
goods[1135] =new setGoods("0000a82198","120","35","30","bp","49000");
goods[1136] =new setGoods("0000a82211","120","40","30","bp","54000");
goods[1137] =new setGoods("0000a82224","120","45","30","bp","59000");
goods[1138] =new setGoods("0000a82237","120","50","30","bp","64000");
goods[1139] =new setGoods("0000a82250","120","55","30","bp","69000");
goods[1140] =new setGoods("0000a82263","120","60","30","bp","74000");
goods[1141] =new setGoods("0000a82186","125","30","30","bp","45000");
goods[1142] =new setGoods("0000a82199","125","35","30","bp","50000");
goods[1143] =new setGoods("0000a82212","125","40","30","bp","55000");
goods[1144] =new setGoods("0000a82225","125","45","30","bp","60000");
goods[1145] =new setGoods("0000a82238","125","50","30","bp","65000");
goods[1146] =new setGoods("0000a82251","125","55","30","bp","70000");
goods[1147] =new setGoods("0000a82264","125","60","30","bp","75000");
goods[1148] =new setGoods("0000a82187","130","30","30","bp","46000");
goods[1149] =new setGoods("0000a82200","130","35","30","bp","51000");
goods[1150] =new setGoods("0000a82213","130","40","30","bp","56000");
goods[1151] =new setGoods("0000a82226","130","45","30","bp","61000");
goods[1152] =new setGoods("0000a82239","130","50","30","bp","66000");
goods[1153] =new setGoods("0000a82252","130","55","30","bp","71000");
goods[1154] =new setGoods("0000a82265","130","60","30","bp","76000");
goods[1155] =new setGoods("0000a82188","135","30","30","bp","47000");
goods[1156] =new setGoods("0000a82201","135","35","30","bp","52000");
goods[1157] =new setGoods("0000a82214","135","40","30","bp","57000");
goods[1158] =new setGoods("0000a82227","135","45","30","bp","62000");
goods[1159] =new setGoods("0000a82240","135","50","30","bp","67000");
goods[1160] =new setGoods("0000a82253","135","55","30","bp","72000");
goods[1161] =new setGoods("0000a82266","135","60","30","bp","77000");
goods[1162] =new setGoods("0000a82189","140","30","30","bp","48000");
goods[1163] =new setGoods("0000a82202","140","35","30","bp","53000");
goods[1164] =new setGoods("0000a82215","140","40","30","bp","58000");
goods[1165] =new setGoods("0000a82228","140","45","30","bp","63000");
goods[1166] =new setGoods("0000a82241","140","50","30","bp","68000");
goods[1167] =new setGoods("0000a82254","140","55","30","bp","73000");
goods[1168] =new setGoods("0000a82267","140","60","30","bp","78000");
goods[1169] =new setGoods("0000a82190","145","30","30","bp","49000");
goods[1170] =new setGoods("0000a82203","145","35","30","bp","54000");
goods[1171] =new setGoods("0000a82216","145","40","30","bp","59000");
goods[1172] =new setGoods("0000a82229","145","45","30","bp","64000");
goods[1173] =new setGoods("0000a82242","145","50","30","bp","69000");
goods[1174] =new setGoods("0000a82255","145","55","30","bp","74000");
goods[1175] =new setGoods("0000a82268","145","60","30","bp","79000");
goods[1176] =new setGoods("0000a82191","150","30","30","bp","50000");
goods[1177] =new setGoods("0000a82204","150","35","30","bp","55000");
goods[1178] =new setGoods("0000a82217","150","40","30","bp","60000");
goods[1179] =new setGoods("0000a82230","150","45","30","bp","65000");
goods[1180] =new setGoods("0000a82243","150","50","30","bp","70000");
goods[1181] =new setGoods("0000a82256","150","55","30","bp","75000");
goods[1182] =new setGoods("0000a82269","150","60","30","bp","80000");
goods[1183] =new setGoods("0000a82270","90","30","42","bp","43000");
goods[1184] =new setGoods("0000a82271","95","30","42","bp","44000");
goods[1185] =new setGoods("0000a82272","100","30","42","bp","45000");
goods[1186] =new setGoods("0000a82273","105","30","42","bp","46000");
goods[1187] =new setGoods("0000a82274","110","30","42","bp","47000");
goods[1188] =new setGoods("0000a82275","115","30","42","bp","48000");
goods[1189] =new setGoods("0000a82276","120","30","42","bp","49000");
goods[1190] =new setGoods("0000a82277","125","30","42","bp","50000");
goods[1191] =new setGoods("0000a82278","130","30","42","bp","51000");
goods[1192] =new setGoods("0000a82279","135","30","42","bp","52000");
goods[1193] =new setGoods("0000a82280","140","30","42","bp","53000");
goods[1194] =new setGoods("0000a82281","145","30","42","bp","54000");
goods[1195] =new setGoods("0000a82282","150","30","42","bp","55000");
goods[1196] =new setGoods("0000a82283","90","35","42","bp","48000");
goods[1197] =new setGoods("0000a82284","95","35","42","bp","49000");
goods[1198] =new setGoods("0000a82285","100","35","42","bp","50000");
goods[1199] =new setGoods("0000a82286","105","35","42","bp","51000");
goods[1200] =new setGoods("0000a82287","110","35","42","bp","52000");
goods[1201] =new setGoods("0000a82288","115","35","42","bp","53000");
goods[1202] =new setGoods("0000a82289","120","35","42","bp","54000");
goods[1203] =new setGoods("0000a82290","125","35","42","bp","55000");
goods[1204] =new setGoods("0000a82291","130","35","42","bp","56000");
goods[1205] =new setGoods("0000a82292","135","35","42","bp","57000");
goods[1206] =new setGoods("0000a82293","140","35","42","bp","58000");
goods[1207] =new setGoods("0000a82294","145","35","42","bp","59000");
goods[1208] =new setGoods("0000a82295","150","35","42","bp","60000");
goods[1209] =new setGoods("0000a82296","90","40","42","bp","53000");
goods[1210] =new setGoods("0000a82297","95","40","42","bp","54000");
goods[1211] =new setGoods("0000a82298","100","40","42","bp","55000");
goods[1212] =new setGoods("0000a82299","105","40","42","bp","56000");
goods[1213] =new setGoods("0000a82300","110","40","42","bp","57000");
goods[1214] =new setGoods("0000a82301","115","40","42","bp","58000");
goods[1215] =new setGoods("0000a82302","120","40","42","bp","59000");
goods[1216] =new setGoods("0000a82303","125","40","42","bp","60000");
goods[1217] =new setGoods("0000a82304","130","40","42","bp","61000");
goods[1218] =new setGoods("0000a82305","135","40","42","bp","62000");
goods[1219] =new setGoods("0000a82306","140","40","42","bp","63000");
goods[1220] =new setGoods("0000a82307","145","40","42","bp","64000");
goods[1221] =new setGoods("0000a82308","150","40","42","bp","65000");
goods[1222] =new setGoods("0000a82309","90","45","42","bp","58000");
goods[1223] =new setGoods("0000a82310","95","45","42","bp","59000");
goods[1224] =new setGoods("0000a82311","100","45","42","bp","60000");
goods[1225] =new setGoods("0000a82312","105","45","42","bp","61000");
goods[1226] =new setGoods("0000a82313","110","45","42","bp","62000");
goods[1227] =new setGoods("0000a82314","115","45","42","bp","63000");
goods[1228] =new setGoods("0000a82315","120","45","42","bp","64000");
goods[1229] =new setGoods("0000a82316","125","45","42","bp","65000");
goods[1230] =new setGoods("0000a82317","130","45","42","bp","66000");
goods[1231] =new setGoods("0000a82318","135","45","42","bp","67000");
goods[1232] =new setGoods("0000a82319","140","45","42","bp","68000");
goods[1233] =new setGoods("0000a82320","145","45","42","bp","69000");
goods[1234] =new setGoods("0000a82321","150","45","42","bp","70000");
goods[1235] =new setGoods("0000a82322","90","50","42","bp","63000");
goods[1236] =new setGoods("0000a82323","95","50","42","bp","64000");
goods[1237] =new setGoods("0000a82324","100","50","42","bp","65000");
goods[1238] =new setGoods("0000a82325","105","50","42","bp","66000");
goods[1239] =new setGoods("0000a82326","110","50","42","bp","67000");
goods[1240] =new setGoods("0000a82327","115","50","42","bp","68000");
goods[1241] =new setGoods("0000a82328","120","50","42","bp","69000");
goods[1242] =new setGoods("0000a82329","125","50","42","bp","70000");
goods[1243] =new setGoods("0000a82330","130","50","42","bp","71000");
goods[1244] =new setGoods("0000a82331","135","50","42","bp","72000");
goods[1245] =new setGoods("0000a82332","140","50","42","bp","73000");
goods[1246] =new setGoods("0000a82333","145","50","42","bp","74000");
goods[1247] =new setGoods("0000a82334","150","50","42","bp","75000");
goods[1248] =new setGoods("0000a82335","90","55","42","bp","68000");
goods[1249] =new setGoods("0000a82336","95","55","42","bp","69000");
goods[1250] =new setGoods("0000a82337","100","55","42","bp","70000");
goods[1251] =new setGoods("0000a82338","105","55","42","bp","71000");
goods[1252] =new setGoods("0000a39402","110","55","42","bp","72000");
goods[1253] =new setGoods("0000a82339","115","55","42","bp","73000");
goods[1254] =new setGoods("0000a82340","120","55","42","bp","74000");
goods[1255] =new setGoods("0000a82341","125","55","42","bp","75000");
goods[1256] =new setGoods("0000a82342","130","55","42","bp","76000");
goods[1257] =new setGoods("0000a82343","135","55","42","bp","77000");
goods[1258] =new setGoods("0000a82344","140","55","42","bp","78000");
goods[1259] =new setGoods("0000a82345","145","55","42","bp","79000");
goods[1260] =new setGoods("0000a82346","150","55","42","bp","80000");
goods[1261] =new setGoods("0000a82347","90","60","42","bp","73000");
goods[1262] =new setGoods("0000a82348","95","60","42","bp","74000");
goods[1263] =new setGoods("0000a82349","100","60","42","bp","75000");
goods[1264] =new setGoods("0000a82350","105","60","42","bp","76000");
goods[1265] =new setGoods("0000a82351","110","60","42","bp","77000");
goods[1266] =new setGoods("0000a82352","115","60","42","bp","78000");
goods[1267] =new setGoods("0000a82353","120","60","42","bp","79000");
goods[1268] =new setGoods("0000a82354","125","60","42","bp","80000");
goods[1269] =new setGoods("0000a82355","130","60","42","bp","81000");
goods[1270] =new setGoods("0000a82356","135","60","42","bp","82000");
goods[1271] =new setGoods("0000a82357","140","60","42","bp","83000");
goods[1272] =new setGoods("0000a82358","145","60","42","bp","84000");
goods[1273] =new setGoods("0000a82359","150","60","42","bp","85000");
goods[1274] =new setGoods("0000a82360","90","30","50","bp","48000");
goods[1275] =new setGoods("0000a82373","90","35","50","bp","53000");
goods[1276] =new setGoods("0000a82386","90","40","50","bp","58000");
goods[1277] =new setGoods("0000a82399","90","45","50","bp","63000");
goods[1278] =new setGoods("0000a82412","90","50","50","bp","68000");
goods[1279] =new setGoods("0000a82425","90","55","50","bp","73000");
goods[1280] =new setGoods("0000a82438","90","60","50","bp","78000");
goods[1281] =new setGoods("0000a82361","95","30","50","bp","49000");
goods[1282] =new setGoods("0000a82374","95","35","50","bp","54000");
goods[1283] =new setGoods("0000a82387","95","40","50","bp","59000");
goods[1284] =new setGoods("0000a82400","95","45","50","bp","64000");
goods[1285] =new setGoods("0000a82413","95","50","50","bp","69000");
goods[1286] =new setGoods("0000a82426","95","55","50","bp","74000");
goods[1287] =new setGoods("0000a82439","95","60","50","bp","79000");
goods[1288] =new setGoods("0000a82362","100","30","50","bp","50000");
goods[1289] =new setGoods("0000a82375","100","35","50","bp","55000");
goods[1290] =new setGoods("0000a82388","100","40","50","bp","60000");
goods[1291] =new setGoods("0000a82401","100","45","50","bp","65000");
goods[1292] =new setGoods("0000a82414","100","50","50","bp","70000");
goods[1293] =new setGoods("0000a82427","100","55","50","bp","75000");
goods[1294] =new setGoods("0000a82440","100","60","50","bp","80000");
goods[1295] =new setGoods("0000a82363","105","30","50","bp","51000");
goods[1296] =new setGoods("0000a82376","105","35","50","bp","56000");
goods[1297] =new setGoods("0000a82389","105","40","50","bp","61000");
goods[1298] =new setGoods("0000a82402","105","45","50","bp","66000");
goods[1299] =new setGoods("0000a82415","105","50","50","bp","71000");
goods[1300] =new setGoods("0000a82428","105","55","50","bp","76000");
goods[1301] =new setGoods("0000a82441","105","60","50","bp","81000");
goods[1302] =new setGoods("0000a82364","110","30","50","bp","52000");
goods[1303] =new setGoods("0000a82377","110","35","50","bp","57000");
goods[1304] =new setGoods("0000a82390","110","40","50","bp","62000");
goods[1305] =new setGoods("0000a82403","110","45","50","bp","67000");
goods[1306] =new setGoods("0000a82416","110","50","50","bp","72000");
goods[1307] =new setGoods("0000a82429","110","55","50","bp","77000");
goods[1308] =new setGoods("0000a82442","110","60","50","bp","82000");
goods[1309] =new setGoods("0000a82365","115","30","50","bp","53000");
goods[1310] =new setGoods("0000a82378","115","35","50","bp","58000");
goods[1311] =new setGoods("0000a82391","115","40","50","bp","63000");
goods[1312] =new setGoods("0000a82404","115","45","50","bp","68000");
goods[1313] =new setGoods("0000a82417","115","50","50","bp","73000");
goods[1314] =new setGoods("0000a82430","115","55","50","bp","78000");
goods[1315] =new setGoods("0000a82443","115","60","50","bp","83000");
goods[1316] =new setGoods("0000a82366","120","30","50","bp","54000");
goods[1317] =new setGoods("0000a82379","120","35","50","bp","59000");
goods[1318] =new setGoods("0000a82392","120","40","50","bp","64000");
goods[1319] =new setGoods("0000a82405","120","45","50","bp","69000");
goods[1320] =new setGoods("0000a82418","120","50","50","bp","74000");
goods[1321] =new setGoods("0000a82431","120","55","50","bp","79000");
goods[1322] =new setGoods("0000a82444","120","60","50","bp","84000");
goods[1323] =new setGoods("0000a82367","125","30","50","bp","55000");
goods[1324] =new setGoods("0000a82380","125","35","50","bp","60000");
goods[1325] =new setGoods("0000a82393","125","40","50","bp","65000");
goods[1326] =new setGoods("0000a82406","125","45","50","bp","70000");
goods[1327] =new setGoods("0000a82419","125","50","50","bp","75000");
goods[1328] =new setGoods("0000a82432","125","55","50","bp","80000");
goods[1329] =new setGoods("0000a82445","125","60","50","bp","85000");
goods[1330] =new setGoods("0000a82368","130","30","50","bp","56000");
goods[1331] =new setGoods("0000a82381","130","35","50","bp","61000");
goods[1332] =new setGoods("0000a82394","130","40","50","bp","66000");
goods[1333] =new setGoods("0000a82407","130","45","50","bp","71000");
goods[1334] =new setGoods("0000a82420","130","50","50","bp","76000");
goods[1335] =new setGoods("0000a82433","130","55","50","bp","81000");
goods[1336] =new setGoods("0000a82446","130","60","50","bp","86000");
goods[1337] =new setGoods("0000a82369","135","30","50","bp","57000");
goods[1338] =new setGoods("0000a82382","135","35","50","bp","62000");
goods[1339] =new setGoods("0000a82395","135","40","50","bp","67000");
goods[1340] =new setGoods("0000a82408","135","45","50","bp","72000");
goods[1341] =new setGoods("0000a82421","135","50","50","bp","77000");
goods[1342] =new setGoods("0000a82434","135","55","50","bp","82000");
goods[1343] =new setGoods("0000a82447","135","60","50","bp","87000");
goods[1344] =new setGoods("0000a82370","140","30","50","bp","58000");
goods[1345] =new setGoods("0000a82383","140","35","50","bp","63000");
goods[1346] =new setGoods("0000a82396","140","40","50","bp","68000");
goods[1347] =new setGoods("0000a82409","140","45","50","bp","73000");
goods[1348] =new setGoods("0000a82422","140","50","50","bp","78000");
goods[1349] =new setGoods("0000a82435","140","55","50","bp","83000");
goods[1350] =new setGoods("0000a82448","140","60","50","bp","88000");
goods[1351] =new setGoods("0000a82371","145","30","50","bp","59000");
goods[1352] =new setGoods("0000a82384","145","35","50","bp","64000");
goods[1353] =new setGoods("0000a82397","145","40","50","bp","69000");
goods[1354] =new setGoods("0000a82410","145","45","50","bp","74000");
goods[1355] =new setGoods("0000a82423","145","50","50","bp","79000");
goods[1356] =new setGoods("0000a82436","145","55","50","bp","84000");
goods[1357] =new setGoods("0000a82449","145","60","50","bp","89000");
goods[1358] =new setGoods("0000a82372","150","30","50","bp","60000");
goods[1359] =new setGoods("0000a82385","150","35","50","bp","65000");
goods[1360] =new setGoods("0000a82398","150","40","50","bp","70000");
goods[1361] =new setGoods("0000a82411","150","45","50","bp","75000");
goods[1362] =new setGoods("0000a82424","150","50","50","bp","80000");
goods[1363] =new setGoods("0000a82437","150","55","50","bp","85000");
goods[1364] =new setGoods("0000a82450","150","60","50","bp","90000");
goods[1365] =new setGoods("0000a82451","90","30","30","mb","45000");
goods[1366] =new setGoods("0000a82464","90","35","30","mb","53000");
goods[1367] =new setGoods("0000a82477","90","40","30","mb","61000");
goods[1368] =new setGoods("0000a82490","90","45","30","mb","69000");
goods[1369] =new setGoods("0000a82503","90","50","30","mb","77000");
goods[1370] =new setGoods("0000a82516","90","55","30","mb","85000");
goods[1371] =new setGoods("0000a82529","90","60","30","mb","93000");
goods[1372] =new setGoods("0000a82452","95","30","30","mb","46000");
goods[1373] =new setGoods("0000a82465","95","35","30","mb","54000");
goods[1374] =new setGoods("0000a82478","95","40","30","mb","62000");
goods[1375] =new setGoods("0000a82491","95","45","30","mb","70000");
goods[1376] =new setGoods("0000a82504","95","50","30","mb","78000");
goods[1377] =new setGoods("0000a82517","95","55","30","mb","86000");
goods[1378] =new setGoods("0000a82530","95","60","30","mb","94000");
goods[1379] =new setGoods("0000a82453","100","30","30","mb","47000");
goods[1380] =new setGoods("0000a82466","100","35","30","mb","55000");
goods[1381] =new setGoods("0000a82479","100","40","30","mb","63000");
goods[1382] =new setGoods("0000a82492","100","45","30","mb","71000");
goods[1383] =new setGoods("0000a82505","100","50","30","mb","79000");
goods[1384] =new setGoods("0000a82518","100","55","30","mb","87000");
goods[1385] =new setGoods("0000a82531","100","60","30","mb","95000");
goods[1386] =new setGoods("0000a82454","105","30","30","mb","48000");
goods[1387] =new setGoods("0000a82467","105","35","30","mb","56000");
goods[1388] =new setGoods("0000a82480","105","40","30","mb","64000");
goods[1389] =new setGoods("0000a82493","105","45","30","mb","72000");
goods[1390] =new setGoods("0000a82506","105","50","30","mb","80000");
goods[1391] =new setGoods("0000a82519","105","55","30","mb","88000");
goods[1392] =new setGoods("0000a82532","105","60","30","mb","96000");
goods[1393] =new setGoods("0000a82455","110","30","30","mb","49000");
goods[1394] =new setGoods("0000a82468","110","35","30","mb","57000");
goods[1395] =new setGoods("0000a82481","110","40","30","mb","65000");
goods[1396] =new setGoods("0000a82494","110","45","30","mb","73000");
goods[1397] =new setGoods("0000a82507","110","50","30","mb","81000");
goods[1398] =new setGoods("0000a82520","110","55","30","mb","89000");
goods[1399] =new setGoods("0000a82533","110","60","30","mb","97000");
goods[1400] =new setGoods("0000a82456","115","30","30","mb","50000");
goods[1401] =new setGoods("0000a82469","115","35","30","mb","58000");
goods[1402] =new setGoods("0000a82482","115","40","30","mb","66000");
goods[1403] =new setGoods("0000a82495","115","45","30","mb","74000");
goods[1404] =new setGoods("0000a82508","115","50","30","mb","82000");
goods[1405] =new setGoods("0000a82521","115","55","30","mb","90000");
goods[1406] =new setGoods("0000a82534","115","60","30","mb","98000");
goods[1407] =new setGoods("0000a82457","120","30","30","mb","51000");
goods[1408] =new setGoods("0000a82470","120","35","30","mb","59000");
goods[1409] =new setGoods("0000a82483","120","40","30","mb","67000");
goods[1410] =new setGoods("0000a82496","120","45","30","mb","75000");
goods[1411] =new setGoods("0000a82509","120","50","30","mb","83000");
goods[1412] =new setGoods("0000a82522","120","55","30","mb","91000");
goods[1413] =new setGoods("0000a82535","120","60","30","mb","99000");
goods[1414] =new setGoods("0000a82458","125","30","30","mb","52000");
goods[1415] =new setGoods("0000a82471","125","35","30","mb","60000");
goods[1416] =new setGoods("0000a82484","125","40","30","mb","68000");
goods[1417] =new setGoods("0000a82497","125","45","30","mb","76000");
goods[1418] =new setGoods("0000a82510","125","50","30","mb","84000");
goods[1419] =new setGoods("0000a82523","125","55","30","mb","92000");
goods[1420] =new setGoods("0000a82536","125","60","30","mb","100000");
goods[1421] =new setGoods("0000a82459","130","30","30","mb","53000");
goods[1422] =new setGoods("0000a82472","130","35","30","mb","61000");
goods[1423] =new setGoods("0000a82485","130","40","30","mb","69000");
goods[1424] =new setGoods("0000a82498","130","45","30","mb","77000");
goods[1425] =new setGoods("0000a82511","130","50","30","mb","85000");
goods[1426] =new setGoods("0000a82524","130","55","30","mb","93000");
goods[1427] =new setGoods("0000a82537","130","60","30","mb","101000");
goods[1428] =new setGoods("0000a82460","135","30","30","mb","54000");
goods[1429] =new setGoods("0000a82473","135","35","30","mb","62000");
goods[1430] =new setGoods("0000a82486","135","40","30","mb","70000");
goods[1431] =new setGoods("0000a82499","135","45","30","mb","78000");
goods[1432] =new setGoods("0000a82512","135","50","30","mb","86000");
goods[1433] =new setGoods("0000a82525","135","55","30","mb","94000");
goods[1434] =new setGoods("0000a82538","135","60","30","mb","102000");
goods[1435] =new setGoods("0000a82461","140","30","30","mb","55000");
goods[1436] =new setGoods("0000a82474","140","35","30","mb","63000");
goods[1437] =new setGoods("0000a82487","140","40","30","mb","71000");
goods[1438] =new setGoods("0000a82500","140","45","30","mb","79000");
goods[1439] =new setGoods("0000a82513","140","50","30","mb","87000");
goods[1440] =new setGoods("0000a82526","140","55","30","mb","95000");
goods[1441] =new setGoods("0000a82539","140","60","30","mb","103000");
goods[1442] =new setGoods("0000a82462","145","30","30","mb","56000");
goods[1443] =new setGoods("0000a82475","145","35","30","mb","64000");
goods[1444] =new setGoods("0000a82488","145","40","30","mb","72000");
goods[1445] =new setGoods("0000a82501","145","45","30","mb","80000");
goods[1446] =new setGoods("0000a82514","145","50","30","mb","88000");
goods[1447] =new setGoods("0000a82527","145","55","30","mb","96000");
goods[1448] =new setGoods("0000a82540","145","60","30","mb","104000");
goods[1449] =new setGoods("0000a82463","150","30","30","mb","57000");
goods[1450] =new setGoods("0000a82476","150","35","30","mb","65000");
goods[1451] =new setGoods("0000a82489","150","40","30","mb","73000");
goods[1452] =new setGoods("0000a82502","150","45","30","mb","81000");
goods[1453] =new setGoods("0000a82515","150","50","30","mb","89000");
goods[1454] =new setGoods("0000a82528","150","55","30","mb","97000");
goods[1455] =new setGoods("0000a82541","150","60","30","mb","105000");
goods[1456] =new setGoods("0000a82542","90","30","42","mb","50000");
goods[1457] =new setGoods("0000a82543","95","30","42","mb","51000");
goods[1458] =new setGoods("0000a82544","100","30","42","mb","52000");
goods[1459] =new setGoods("0000a82545","105","30","42","mb","53000");
goods[1460] =new setGoods("0000a82546","110","30","42","mb","54000");
goods[1461] =new setGoods("0000a82547","115","30","42","mb","55000");
goods[1462] =new setGoods("0000a82548","120","30","42","mb","56000");
goods[1463] =new setGoods("0000a82549","125","30","42","mb","57000");
goods[1464] =new setGoods("0000a82550","130","30","42","mb","58000");
goods[1465] =new setGoods("0000a82551","135","30","42","mb","59000");
goods[1466] =new setGoods("0000a82552","140","30","42","mb","60000");
goods[1467] =new setGoods("0000a82553","145","30","42","mb","61000");
goods[1468] =new setGoods("0000a82554","150","30","42","mb","62000");
goods[1469] =new setGoods("0000a82555","90","35","42","mb","58000");
goods[1470] =new setGoods("0000a82556","95","35","42","mb","59000");
goods[1471] =new setGoods("0000a82557","100","35","42","mb","60000");
goods[1472] =new setGoods("0000a82558","105","35","42","mb","61000");
goods[1473] =new setGoods("0000a82559","110","35","42","mb","62000");
goods[1474] =new setGoods("0000a82560","115","35","42","mb","63000");
goods[1475] =new setGoods("0000a82561","120","35","42","mb","64000");
goods[1476] =new setGoods("0000a82562","125","35","42","mb","65000");
goods[1477] =new setGoods("0000a82563","130","35","42","mb","66000");
goods[1478] =new setGoods("0000a82564","135","35","42","mb","67000");
goods[1479] =new setGoods("0000a82565","140","35","42","mb","68000");
goods[1480] =new setGoods("0000a82566","145","35","42","mb","69000");
goods[1481] =new setGoods("0000a82567","150","35","42","mb","70000");
goods[1482] =new setGoods("0000a82568","90","40","42","mb","66000");
goods[1483] =new setGoods("0000a82569","95","40","42","mb","67000");
goods[1484] =new setGoods("0000a82570","100","40","42","mb","68000");
goods[1485] =new setGoods("0000a82571","105","40","42","mb","69000");
goods[1486] =new setGoods("0000a82572","110","40","42","mb","70000");
goods[1487] =new setGoods("0000a82573","115","40","42","mb","71000");
goods[1488] =new setGoods("0000a82574","120","40","42","mb","72000");
goods[1489] =new setGoods("0000a82575","125","40","42","mb","73000");
goods[1490] =new setGoods("0000a82576","130","40","42","mb","74000");
goods[1491] =new setGoods("0000a82577","135","40","42","mb","75000");
goods[1492] =new setGoods("0000a82578","140","40","42","mb","76000");
goods[1493] =new setGoods("0000a82579","145","40","42","mb","77000");
goods[1494] =new setGoods("0000a82580","150","40","42","mb","78000");
goods[1495] =new setGoods("0000a82581","90","45","42","mb","74000");
goods[1496] =new setGoods("0000a82582","95","45","42","mb","75000");
goods[1497] =new setGoods("0000a82583","100","45","42","mb","76000");
goods[1498] =new setGoods("0000a82584","105","45","42","mb","77000");
goods[1499] =new setGoods("0000a82585","110","45","42","mb","78000");
goods[1500] =new setGoods("0000a82586","115","45","42","mb","79000");
goods[1501] =new setGoods("0000a82587","120","45","42","mb","80000");
goods[1502] =new setGoods("0000a82588","125","45","42","mb","81000");
goods[1503] =new setGoods("0000a82589","130","45","42","mb","82000");
goods[1504] =new setGoods("0000a82590","135","45","42","mb","83000");
goods[1505] =new setGoods("0000a82591","140","45","42","mb","84000");
goods[1506] =new setGoods("0000a82592","145","45","42","mb","85000");
goods[1507] =new setGoods("0000a82593","150","45","42","mb","86000");
goods[1508] =new setGoods("0000a82594","90","50","42","mb","82000");
goods[1509] =new setGoods("0000a82595","95","50","42","mb","83000");
goods[1510] =new setGoods("0000a82596","100","50","42","mb","84000");
goods[1511] =new setGoods("0000a82597","105","50","42","mb","85000");
goods[1512] =new setGoods("0000a82598","110","50","42","mb","86000");
goods[1513] =new setGoods("0000a82599","115","50","42","mb","87000");
goods[1514] =new setGoods("0000a82600","120","50","42","mb","88000");
goods[1515] =new setGoods("0000a82601","125","50","42","mb","89000");
goods[1516] =new setGoods("0000a82602","130","50","42","mb","90000");
goods[1517] =new setGoods("0000a82603","135","50","42","mb","91000");
goods[1518] =new setGoods("0000a82604","140","50","42","mb","92000");
goods[1519] =new setGoods("0000a82605","145","50","42","mb","93000");
goods[1520] =new setGoods("0000a82606","150","50","42","mb","94000");
goods[1521] =new setGoods("0000a82607","90","55","42","mb","90000");
goods[1522] =new setGoods("0000a82608","95","55","42","mb","91000");
goods[1523] =new setGoods("0000a82609","100","55","42","mb","92000");
goods[1524] =new setGoods("0000a82610","105","55","42","mb","93000");
goods[1525] =new setGoods("0000a39428","110","55","42","mb","94000");
goods[1526] =new setGoods("0000a82611","115","55","42","mb","95000");
goods[1527] =new setGoods("0000a82612","120","55","42","mb","96000");
goods[1528] =new setGoods("0000a82613","125","55","42","mb","97000");
goods[1529] =new setGoods("0000a82614","130","55","42","mb","98000");
goods[1530] =new setGoods("0000a82615","135","55","42","mb","99000");
goods[1531] =new setGoods("0000a82616","140","55","42","mb","100000");
goods[1532] =new setGoods("0000a82617","145","55","42","mb","101000");
goods[1533] =new setGoods("0000a82618","150","55","42","mb","102000");
goods[1534] =new setGoods("0000a82619","90","60","42","mb","98000");
goods[1535] =new setGoods("0000a82620","95","60","42","mb","99000");
goods[1536] =new setGoods("0000a82621","100","60","42","mb","100000");
goods[1537] =new setGoods("0000a82622","105","60","42","mb","101000");
goods[1538] =new setGoods("0000a82623","110","60","42","mb","102000");
goods[1539] =new setGoods("0000a82624","115","60","42","mb","103000");
goods[1540] =new setGoods("0000a82625","120","60","42","mb","104000");
goods[1541] =new setGoods("0000a82626","125","60","42","mb","105000");
goods[1542] =new setGoods("0000a82627","130","60","42","mb","106000");
goods[1543] =new setGoods("0000a82628","135","60","42","mb","107000");
goods[1544] =new setGoods("0000a82629","140","60","42","mb","108000");
goods[1545] =new setGoods("0000a82630","145","60","42","mb","109000");
goods[1546] =new setGoods("0000a82631","150","60","42","mb","110000");
goods[1547] =new setGoods("0000a82632","90","30","50","mb","55000");
goods[1548] =new setGoods("0000a82645","90","35","50","mb","63000");
goods[1549] =new setGoods("0000a82658","90","40","50","mb","71000");
goods[1550] =new setGoods("0000a82671","90","45","50","mb","79000");
goods[1551] =new setGoods("0000a82684","90","50","50","mb","87000");
goods[1552] =new setGoods("0000a82697","90","55","50","mb","95000");
goods[1553] =new setGoods("0000a82710","90","60","50","mb","103000");
goods[1554] =new setGoods("0000a82633","95","30","50","mb","56000");
goods[1555] =new setGoods("0000a82646","95","35","50","mb","64000");
goods[1556] =new setGoods("0000a82659","95","40","50","mb","72000");
goods[1557] =new setGoods("0000a82672","95","45","50","mb","80000");
goods[1558] =new setGoods("0000a82685","95","50","50","mb","88000");
goods[1559] =new setGoods("0000a82698","95","55","50","mb","96000");
goods[1560] =new setGoods("0000a82711","95","60","50","mb","104000");
goods[1561] =new setGoods("0000a82634","100","30","50","mb","57000");
goods[1562] =new setGoods("0000a82647","100","35","50","mb","65000");
goods[1563] =new setGoods("0000a82660","100","40","50","mb","73000");
goods[1564] =new setGoods("0000a82673","100","45","50","mb","81000");
goods[1565] =new setGoods("0000a82686","100","50","50","mb","89000");
goods[1566] =new setGoods("0000a82699","100","55","50","mb","97000");
goods[1567] =new setGoods("0000a82712","100","60","50","mb","105000");
goods[1568] =new setGoods("0000a82635","105","30","50","mb","58000");
goods[1569] =new setGoods("0000a82648","105","35","50","mb","66000");
goods[1570] =new setGoods("0000a82661","105","40","50","mb","74000");
goods[1571] =new setGoods("0000a82674","105","45","50","mb","82000");
goods[1572] =new setGoods("0000a82687","105","50","50","mb","90000");
goods[1573] =new setGoods("0000a82700","105","55","50","mb","98000");
goods[1574] =new setGoods("0000a82713","105","60","50","mb","106000");
goods[1575] =new setGoods("0000a82636","110","30","50","mb","59000");
goods[1576] =new setGoods("0000a82649","110","35","50","mb","67000");
goods[1577] =new setGoods("0000a82662","110","40","50","mb","75000");
goods[1578] =new setGoods("0000a82675","110","45","50","mb","83000");
goods[1579] =new setGoods("0000a82688","110","50","50","mb","91000");
goods[1580] =new setGoods("0000a82701","110","55","50","mb","99000");
goods[1581] =new setGoods("0000a82714","110","60","50","mb","107000");
goods[1582] =new setGoods("0000a82637","115","30","50","mb","60000");
goods[1583] =new setGoods("0000a82650","115","35","50","mb","68000");
goods[1584] =new setGoods("0000a82663","115","40","50","mb","76000");
goods[1585] =new setGoods("0000a82676","115","45","50","mb","84000");
goods[1586] =new setGoods("0000a82689","115","50","50","mb","92000");
goods[1587] =new setGoods("0000a82702","115","55","50","mb","100000");
goods[1588] =new setGoods("0000a82715","115","60","50","mb","108000");
goods[1589] =new setGoods("0000a82638","120","30","50","mb","61000");
goods[1590] =new setGoods("0000a82651","120","35","50","mb","69000");
goods[1591] =new setGoods("0000a82664","120","40","50","mb","77000");
goods[1592] =new setGoods("0000a82677","120","45","50","mb","85000");
goods[1593] =new setGoods("0000a82690","120","50","50","mb","93000");
goods[1594] =new setGoods("0000a82703","120","55","50","mb","101000");
goods[1595] =new setGoods("0000a82716","120","60","50","mb","109000");
goods[1596] =new setGoods("0000a82639","125","30","50","mb","62000");
goods[1597] =new setGoods("0000a82652","125","35","50","mb","70000");
goods[1598] =new setGoods("0000a82665","125","40","50","mb","78000");
goods[1599] =new setGoods("0000a82678","125","45","50","mb","86000");
goods[1600] =new setGoods("0000a82691","125","50","50","mb","94000");
goods[1601] =new setGoods("0000a82704","125","55","50","mb","102000");
goods[1602] =new setGoods("0000a82717","125","60","50","mb","110000");
goods[1603] =new setGoods("0000a82640","130","30","50","mb","63000");
goods[1604] =new setGoods("0000a82653","130","35","50","mb","71000");
goods[1605] =new setGoods("0000a82666","130","40","50","mb","79000");
goods[1606] =new setGoods("0000a82679","130","45","50","mb","87000");
goods[1607] =new setGoods("0000a82692","130","50","50","mb","95000");
goods[1608] =new setGoods("0000a82705","130","55","50","mb","103000");
goods[1609] =new setGoods("0000a82718","130","60","50","mb","111000");
goods[1610] =new setGoods("0000a82641","135","30","50","mb","64000");
goods[1611] =new setGoods("0000a82654","135","35","50","mb","72000");
goods[1612] =new setGoods("0000a82667","135","40","50","mb","80000");
goods[1613] =new setGoods("0000a82680","135","45","50","mb","88000");
goods[1614] =new setGoods("0000a82693","135","50","50","mb","96000");
goods[1615] =new setGoods("0000a82706","135","55","50","mb","104000");
goods[1616] =new setGoods("0000a82719","135","60","50","mb","112000");
goods[1617] =new setGoods("0000a82642","140","30","50","mb","65000");
goods[1618] =new setGoods("0000a82655","140","35","50","mb","73000");
goods[1619] =new setGoods("0000a82668","140","40","50","mb","81000");
goods[1620] =new setGoods("0000a82681","140","45","50","mb","89000");
goods[1621] =new setGoods("0000a82694","140","50","50","mb","97000");
goods[1622] =new setGoods("0000a82707","140","55","50","mb","105000");
goods[1623] =new setGoods("0000a82720","140","60","50","mb","113000");
goods[1624] =new setGoods("0000a82643","145","30","50","mb","66000");
goods[1625] =new setGoods("0000a82656","145","35","50","mb","74000");
goods[1626] =new setGoods("0000a82669","145","40","50","mb","82000");
goods[1627] =new setGoods("0000a82682","145","45","50","mb","90000");
goods[1628] =new setGoods("0000a82695","145","50","50","mb","98000");
goods[1629] =new setGoods("0000a82708","145","55","50","mb","106000");
goods[1630] =new setGoods("0000a82721","145","60","50","mb","114000");
goods[1631] =new setGoods("0000a82644","150","30","50","mb","67000");
goods[1632] =new setGoods("0000a82657","150","35","50","mb","75000");
goods[1633] =new setGoods("0000a82670","150","40","50","mb","83000");
goods[1634] =new setGoods("0000a82683","150","45","50","mb","91000");
goods[1635] =new setGoods("0000a82696","150","50","50","mb","99000");
goods[1636] =new setGoods("0000a82709","150","55","50","mb","107000");
goods[1637] =new setGoods("0000a82722","150","60","50","mb","115000");
goods[1638] =new setGoods("0000a82723","90","30","30","gs","45000");
goods[1639] =new setGoods("0000a82736","90","35","30","gs","53000");
goods[1640] =new setGoods("0000a82749","90","40","30","gs","61000");
goods[1641] =new setGoods("0000a82762","90","45","30","gs","69000");
goods[1642] =new setGoods("0000a82775","90","50","30","gs","77000");
goods[1643] =new setGoods("0000a82788","90","55","30","gs","85000");
goods[1644] =new setGoods("0000a82801","90","60","30","gs","93000");
goods[1645] =new setGoods("0000a82724","95","30","30","gs","46000");
goods[1646] =new setGoods("0000a82737","95","35","30","gs","54000");
goods[1647] =new setGoods("0000a82750","95","40","30","gs","62000");
goods[1648] =new setGoods("0000a82763","95","45","30","gs","70000");
goods[1649] =new setGoods("0000a82776","95","50","30","gs","78000");
goods[1650] =new setGoods("0000a82789","95","55","30","gs","86000");
goods[1651] =new setGoods("0000a82802","95","60","30","gs","94000");
goods[1652] =new setGoods("0000a82725","100","30","30","gs","47000");
goods[1653] =new setGoods("0000a82738","100","35","30","gs","55000");
goods[1654] =new setGoods("0000a82751","100","40","30","gs","63000");
goods[1655] =new setGoods("0000a82764","100","45","30","gs","71000");
goods[1656] =new setGoods("0000a82777","100","50","30","gs","79000");
goods[1657] =new setGoods("0000a82790","100","55","30","gs","87000");
goods[1658] =new setGoods("0000a82803","100","60","30","gs","95000");
goods[1659] =new setGoods("0000a82726","105","30","30","gs","48000");
goods[1660] =new setGoods("0000a82739","105","35","30","gs","56000");
goods[1661] =new setGoods("0000a82752","105","40","30","gs","64000");
goods[1662] =new setGoods("0000a82765","105","45","30","gs","72000");
goods[1663] =new setGoods("0000a82778","105","50","30","gs","80000");
goods[1664] =new setGoods("0000a82791","105","55","30","gs","88000");
goods[1665] =new setGoods("0000a82804","105","60","30","gs","96000");
goods[1666] =new setGoods("0000a82727","110","30","30","gs","49000");
goods[1667] =new setGoods("0000a82740","110","35","30","gs","57000");
goods[1668] =new setGoods("0000a82753","110","40","30","gs","65000");
goods[1669] =new setGoods("0000a82766","110","45","30","gs","73000");
goods[1670] =new setGoods("0000a82779","110","50","30","gs","81000");
goods[1671] =new setGoods("0000a82792","110","55","30","gs","89000");
goods[1672] =new setGoods("0000a82805","110","60","30","gs","97000");
goods[1673] =new setGoods("0000a82728","115","30","30","gs","50000");
goods[1674] =new setGoods("0000a82741","115","35","30","gs","58000");
goods[1675] =new setGoods("0000a82754","115","40","30","gs","66000");
goods[1676] =new setGoods("0000a82767","115","45","30","gs","74000");
goods[1677] =new setGoods("0000a82780","115","50","30","gs","82000");
goods[1678] =new setGoods("0000a82793","115","55","30","gs","90000");
goods[1679] =new setGoods("0000a82806","115","60","30","gs","98000");
goods[1680] =new setGoods("0000a82729","120","30","30","gs","51000");
goods[1681] =new setGoods("0000a82742","120","35","30","gs","59000");
goods[1682] =new setGoods("0000a82755","120","40","30","gs","67000");
goods[1683] =new setGoods("0000a82768","120","45","30","gs","75000");
goods[1684] =new setGoods("0000a82781","120","50","30","gs","83000");
goods[1685] =new setGoods("0000a82794","120","55","30","gs","91000");
goods[1686] =new setGoods("0000a82807","120","60","30","gs","99000");
goods[1687] =new setGoods("0000a82730","125","30","30","gs","52000");
goods[1688] =new setGoods("0000a82743","125","35","30","gs","60000");
goods[1689] =new setGoods("0000a82756","125","40","30","gs","68000");
goods[1690] =new setGoods("0000a82769","125","45","30","gs","76000");
goods[1691] =new setGoods("0000a82782","125","50","30","gs","84000");
goods[1692] =new setGoods("0000a82795","125","55","30","gs","92000");
goods[1693] =new setGoods("0000a82808","125","60","30","gs","100000");
goods[1694] =new setGoods("0000a82731","130","30","30","gs","53000");
goods[1695] =new setGoods("0000a82744","130","35","30","gs","61000");
goods[1696] =new setGoods("0000a82757","130","40","30","gs","69000");
goods[1697] =new setGoods("0000a82770","130","45","30","gs","77000");
goods[1698] =new setGoods("0000a82783","130","50","30","gs","85000");
goods[1699] =new setGoods("0000a82796","130","55","30","gs","93000");
goods[1700] =new setGoods("0000a82809","130","60","30","gs","101000");
goods[1701] =new setGoods("0000a82732","135","30","30","gs","54000");
goods[1702] =new setGoods("0000a82745","135","35","30","gs","62000");
goods[1703] =new setGoods("0000a82758","135","40","30","gs","70000");
goods[1704] =new setGoods("0000a82771","135","45","30","gs","78000");
goods[1705] =new setGoods("0000a82784","135","50","30","gs","86000");
goods[1706] =new setGoods("0000a82797","135","55","30","gs","94000");
goods[1707] =new setGoods("0000a82810","135","60","30","gs","102000");
goods[1708] =new setGoods("0000a82733","140","30","30","gs","55000");
goods[1709] =new setGoods("0000a82746","140","35","30","gs","63000");
goods[1710] =new setGoods("0000a82759","140","40","30","gs","71000");
goods[1711] =new setGoods("0000a82772","140","45","30","gs","79000");
goods[1712] =new setGoods("0000a82785","140","50","30","gs","87000");
goods[1713] =new setGoods("0000a82798","140","55","30","gs","95000");
goods[1714] =new setGoods("0000a82811","140","60","30","gs","103000");
goods[1715] =new setGoods("0000a82734","145","30","30","gs","56000");
goods[1716] =new setGoods("0000a82747","145","35","30","gs","64000");
goods[1717] =new setGoods("0000a82760","145","40","30","gs","72000");
goods[1718] =new setGoods("0000a82773","145","45","30","gs","80000");
goods[1719] =new setGoods("0000a82786","145","50","30","gs","88000");
goods[1720] =new setGoods("0000a82799","145","55","30","gs","96000");
goods[1721] =new setGoods("0000a82812","145","60","30","gs","104000");
goods[1722] =new setGoods("0000a82735","150","30","30","gs","57000");
goods[1723] =new setGoods("0000a82748","150","35","30","gs","65000");
goods[1724] =new setGoods("0000a82761","150","40","30","gs","73000");
goods[1725] =new setGoods("0000a82774","150","45","30","gs","81000");
goods[1726] =new setGoods("0000a82787","150","50","30","gs","89000");
goods[1727] =new setGoods("0000a82800","150","55","30","gs","97000");
goods[1728] =new setGoods("0000a82813","150","60","30","gs","105000");
goods[1729] =new setGoods("0000a82814","90","30","42","gs","50000");
goods[1730] =new setGoods("0000a82815","95","30","42","gs","51000");
goods[1731] =new setGoods("0000a82816","100","30","42","gs","52000");
goods[1732] =new setGoods("0000a82817","105","30","42","gs","53000");
goods[1733] =new setGoods("0000a82818","110","30","42","gs","54000");
goods[1734] =new setGoods("0000a82819","115","30","42","gs","55000");
goods[1735] =new setGoods("0000a82820","120","30","42","gs","56000");
goods[1736] =new setGoods("0000a82821","125","30","42","gs","57000");
goods[1737] =new setGoods("0000a82822","130","30","42","gs","58000");
goods[1738] =new setGoods("0000a82823","135","30","42","gs","59000");
goods[1739] =new setGoods("0000a82824","140","30","42","gs","60000");
goods[1740] =new setGoods("0000a82825","145","30","42","gs","61000");
goods[1741] =new setGoods("0000a82826","150","30","42","gs","62000");
goods[1742] =new setGoods("0000a82827","90","35","42","gs","58000");
goods[1743] =new setGoods("0000a82828","95","35","42","gs","59000");
goods[1744] =new setGoods("0000a82829","100","35","42","gs","60000");
goods[1745] =new setGoods("0000a82830","105","35","42","gs","61000");
goods[1746] =new setGoods("0000a82831","110","35","42","gs","62000");
goods[1747] =new setGoods("0000a82832","115","35","42","gs","63000");
goods[1748] =new setGoods("0000a82833","120","35","42","gs","64000");
goods[1749] =new setGoods("0000a82834","125","35","42","gs","65000");
goods[1750] =new setGoods("0000a82835","130","35","42","gs","66000");
goods[1751] =new setGoods("0000a82836","135","35","42","gs","67000");
goods[1752] =new setGoods("0000a82837","140","35","42","gs","68000");
goods[1753] =new setGoods("0000a82838","145","35","42","gs","69000");
goods[1754] =new setGoods("0000a82839","150","35","42","gs","70000");
goods[1755] =new setGoods("0000a82840","90","40","42","gs","66000");
goods[1756] =new setGoods("0000a82841","95","40","42","gs","67000");
goods[1757] =new setGoods("0000a82842","100","40","42","gs","68000");
goods[1758] =new setGoods("0000a82843","105","40","42","gs","69000");
goods[1759] =new setGoods("0000a82844","110","40","42","gs","70000");
goods[1760] =new setGoods("0000a82845","115","40","42","gs","71000");
goods[1761] =new setGoods("0000a82846","120","40","42","gs","72000");
goods[1762] =new setGoods("0000a82847","125","40","42","gs","73000");
goods[1763] =new setGoods("0000a82848","130","40","42","gs","74000");
goods[1764] =new setGoods("0000a82849","135","40","42","gs","75000");
goods[1765] =new setGoods("0000a82850","140","40","42","gs","76000");
goods[1766] =new setGoods("0000a82851","145","40","42","gs","77000");
goods[1767] =new setGoods("0000a82852","150","40","42","gs","78000");
goods[1768] =new setGoods("0000a82853","90","45","42","gs","74000");
goods[1769] =new setGoods("0000a82854","95","45","42","gs","75000");
goods[1770] =new setGoods("0000a82855","100","45","42","gs","76000");
goods[1771] =new setGoods("0000a82856","105","45","42","gs","77000");
goods[1772] =new setGoods("0000a82857","110","45","42","gs","78000");
goods[1773] =new setGoods("0000a82858","115","45","42","gs","79000");
goods[1774] =new setGoods("0000a82859","120","45","42","gs","80000");
goods[1775] =new setGoods("0000a82860","125","45","42","gs","81000");
goods[1776] =new setGoods("0000a82861","130","45","42","gs","82000");
goods[1777] =new setGoods("0000a82862","135","45","42","gs","83000");
goods[1778] =new setGoods("0000a82863","140","45","42","gs","84000");
goods[1779] =new setGoods("0000a82864","145","45","42","gs","85000");
goods[1780] =new setGoods("0000a82865","150","45","42","gs","86000");
goods[1781] =new setGoods("0000a82866","90","50","42","gs","82000");
goods[1782] =new setGoods("0000a82867","95","50","42","gs","83000");
goods[1783] =new setGoods("0000a82868","100","50","42","gs","84000");
goods[1784] =new setGoods("0000a82869","105","50","42","gs","85000");
goods[1785] =new setGoods("0000a82870","110","50","42","gs","86000");
goods[1786] =new setGoods("0000a82871","115","50","42","gs","87000");
goods[1787] =new setGoods("0000a82872","120","50","42","gs","88000");
goods[1788] =new setGoods("0000a82873","125","50","42","gs","89000");
goods[1789] =new setGoods("0000a82874","130","50","42","gs","90000");
goods[1790] =new setGoods("0000a82875","135","50","42","gs","91000");
goods[1791] =new setGoods("0000a82876","140","50","42","gs","92000");
goods[1792] =new setGoods("0000a82877","145","50","42","gs","93000");
goods[1793] =new setGoods("0000a82878","150","50","42","gs","94000");
goods[1794] =new setGoods("0000a82879","90","55","42","gs","90000");
goods[1795] =new setGoods("0000a82880","95","55","42","gs","91000");
goods[1796] =new setGoods("0000a82881","100","55","42","gs","92000");
goods[1797] =new setGoods("0000a82882","105","55","42","gs","93000");
goods[1798] =new setGoods("0000a41874","110","55","42","gs","94000");
goods[1799] =new setGoods("0000a82883","115","55","42","gs","95000");
goods[1800] =new setGoods("0000a82884","120","55","42","gs","96000");
goods[1801] =new setGoods("0000a82885","125","55","42","gs","97000");
goods[1802] =new setGoods("0000a82886","130","55","42","gs","98000");
goods[1803] =new setGoods("0000a82887","135","55","42","gs","99000");
goods[1804] =new setGoods("0000a82888","140","55","42","gs","100000");
goods[1805] =new setGoods("0000a82889","145","55","42","gs","101000");
goods[1806] =new setGoods("0000a82890","150","55","42","gs","102000");
goods[1807] =new setGoods("0000a82891","90","60","42","gs","98000");
goods[1808] =new setGoods("0000a82892","95","60","42","gs","99000");
goods[1809] =new setGoods("0000a82893","100","60","42","gs","100000");
goods[1810] =new setGoods("0000a82894","105","60","42","gs","101000");
goods[1811] =new setGoods("0000a82895","110","60","42","gs","102000");
goods[1812] =new setGoods("0000a82896","115","60","42","gs","103000");
goods[1813] =new setGoods("0000a82897","120","60","42","gs","104000");
goods[1814] =new setGoods("0000a82898","125","60","42","gs","105000");
goods[1815] =new setGoods("0000a82899","130","60","42","gs","106000");
goods[1816] =new setGoods("0000a82900","135","60","42","gs","107000");
goods[1817] =new setGoods("0000a82901","140","60","42","gs","108000");
goods[1818] =new setGoods("0000a82902","145","60","42","gs","109000");
goods[1819] =new setGoods("0000a82903","150","60","42","gs","110000");
goods[1820] =new setGoods("0000a82904","90","30","50","gs","55000");
goods[1821] =new setGoods("0000a82917","90","35","50","gs","63000");
goods[1822] =new setGoods("0000a82930","90","40","50","gs","71000");
goods[1823] =new setGoods("0000a82943","90","45","50","gs","79000");
goods[1824] =new setGoods("0000a82956","90","50","50","gs","87000");
goods[1825] =new setGoods("0000a82969","90","55","50","gs","95000");
goods[1826] =new setGoods("0000a82982","90","60","50","gs","103000");
goods[1827] =new setGoods("0000a82905","95","30","50","gs","56000");
goods[1828] =new setGoods("0000a82918","95","35","50","gs","64000");
goods[1829] =new setGoods("0000a82931","95","40","50","gs","72000");
goods[1830] =new setGoods("0000a82944","95","45","50","gs","80000");
goods[1831] =new setGoods("0000a82957","95","50","50","gs","88000");
goods[1832] =new setGoods("0000a82970","95","55","50","gs","96000");
goods[1833] =new setGoods("0000a82983","95","60","50","gs","104000");
goods[1834] =new setGoods("0000a82906","100","30","50","gs","57000");
goods[1835] =new setGoods("0000a82919","100","35","50","gs","65000");
goods[1836] =new setGoods("0000a82932","100","40","50","gs","73000");
goods[1837] =new setGoods("0000a82945","100","45","50","gs","81000");
goods[1838] =new setGoods("0000a82958","100","50","50","gs","89000");
goods[1839] =new setGoods("0000a82971","100","55","50","gs","97000");
goods[1840] =new setGoods("0000a82984","100","60","50","gs","105000");
goods[1841] =new setGoods("0000a82907","105","30","50","gs","58000");
goods[1842] =new setGoods("0000a82920","105","35","50","gs","66000");
goods[1843] =new setGoods("0000a82933","105","40","50","gs","74000");
goods[1844] =new setGoods("0000a82946","105","45","50","gs","82000");
goods[1845] =new setGoods("0000a82959","105","50","50","gs","90000");
goods[1846] =new setGoods("0000a82972","105","55","50","gs","98000");
goods[1847] =new setGoods("0000a82985","105","60","50","gs","106000");
goods[1848] =new setGoods("0000a82908","110","30","50","gs","59000");
goods[1849] =new setGoods("0000a82921","110","35","50","gs","67000");
goods[1850] =new setGoods("0000a82934","110","40","50","gs","75000");
goods[1851] =new setGoods("0000a82947","110","45","50","gs","83000");
goods[1852] =new setGoods("0000a82960","110","50","50","gs","91000");
goods[1853] =new setGoods("0000a82973","110","55","50","gs","99000");
goods[1854] =new setGoods("0000a82986","110","60","50","gs","107000");
goods[1855] =new setGoods("0000a82909","115","30","50","gs","60000");
goods[1856] =new setGoods("0000a82922","115","35","50","gs","68000");
goods[1857] =new setGoods("0000a82935","115","40","50","gs","76000");
goods[1858] =new setGoods("0000a82948","115","45","50","gs","84000");
goods[1859] =new setGoods("0000a82961","115","50","50","gs","92000");
goods[1860] =new setGoods("0000a82974","115","55","50","gs","100000");
goods[1861] =new setGoods("0000a82987","115","60","50","gs","108000");
goods[1862] =new setGoods("0000a82910","120","30","50","gs","61000");
goods[1863] =new setGoods("0000a82923","120","35","50","gs","69000");
goods[1864] =new setGoods("0000a82936","120","40","50","gs","77000");
goods[1865] =new setGoods("0000a82949","120","45","50","gs","85000");
goods[1866] =new setGoods("0000a82962","120","50","50","gs","93000");
goods[1867] =new setGoods("0000a82975","120","55","50","gs","101000");
goods[1868] =new setGoods("0000a82988","120","60","50","gs","109000");
goods[1869] =new setGoods("0000a82911","125","30","50","gs","62000");
goods[1870] =new setGoods("0000a82924","125","35","50","gs","70000");
goods[1871] =new setGoods("0000a82937","125","40","50","gs","78000");
goods[1872] =new setGoods("0000a82950","125","45","50","gs","86000");
goods[1873] =new setGoods("0000a82963","125","50","50","gs","94000");
goods[1874] =new setGoods("0000a82976","125","55","50","gs","102000");
goods[1875] =new setGoods("0000a82989","125","60","50","gs","110000");
goods[1876] =new setGoods("0000a82912","130","30","50","gs","63000");
goods[1877] =new setGoods("0000a82925","130","35","50","gs","71000");
goods[1878] =new setGoods("0000a82938","130","40","50","gs","79000");
goods[1879] =new setGoods("0000a82951","130","45","50","gs","87000");
goods[1880] =new setGoods("0000a82964","130","50","50","gs","95000");
goods[1881] =new setGoods("0000a82977","130","55","50","gs","103000");
goods[1882] =new setGoods("0000a82990","130","60","50","gs","111000");
goods[1883] =new setGoods("0000a82913","135","30","50","gs","64000");
goods[1884] =new setGoods("0000a82926","135","35","50","gs","72000");
goods[1885] =new setGoods("0000a82939","135","40","50","gs","80000");
goods[1886] =new setGoods("0000a82952","135","45","50","gs","88000");
goods[1887] =new setGoods("0000a82965","135","50","50","gs","96000");
goods[1888] =new setGoods("0000a82978","135","55","50","gs","104000");
goods[1889] =new setGoods("0000a82991","135","60","50","gs","112000");
goods[1890] =new setGoods("0000a82914","140","30","50","gs","65000");
goods[1891] =new setGoods("0000a82927","140","35","50","gs","73000");
goods[1892] =new setGoods("0000a82940","140","40","50","gs","81000");
goods[1893] =new setGoods("0000a82953","140","45","50","gs","89000");
goods[1894] =new setGoods("0000a82966","140","50","50","gs","97000");
goods[1895] =new setGoods("0000a82979","140","55","50","gs","105000");
goods[1896] =new setGoods("0000a82992","140","60","50","gs","113000");
goods[1897] =new setGoods("0000a82915","145","30","50","gs","66000");
goods[1898] =new setGoods("0000a82928","145","35","50","gs","74000");
goods[1899] =new setGoods("0000a82941","145","40","50","gs","82000");
goods[1900] =new setGoods("0000a82954","145","45","50","gs","90000");
goods[1901] =new setGoods("0000a82967","145","50","50","gs","98000");
goods[1902] =new setGoods("0000a82980","145","55","50","gs","106000");
goods[1903] =new setGoods("0000a82993","145","60","50","gs","114000");
goods[1904] =new setGoods("0000a82916","150","30","50","gs","67000");
goods[1905] =new setGoods("0000a82929","150","35","50","gs","75000");
goods[1906] =new setGoods("0000a82942","150","40","50","gs","83000");
goods[1907] =new setGoods("0000a82955","150","45","50","gs","91000");
goods[1908] =new setGoods("0000a82968","150","50","50","gs","99000");
goods[1909] =new setGoods("0000a82981","150","55","50","gs","107000");
goods[1910] =new setGoods("0000a82994","150","60","50","gs","115000");
goods[1911] =new setGoods("0000a82995","90","30","30","ww","45000");
goods[1912] =new setGoods("0000a83008","90","35","30","ww","53000");
goods[1913] =new setGoods("0000a83021","90","40","30","ww","61000");
goods[1914] =new setGoods("0000a83034","90","45","30","ww","69000");
goods[1915] =new setGoods("0000a83047","90","50","30","ww","77000");
goods[1916] =new setGoods("0000a83060","90","55","30","ww","85000");
goods[1917] =new setGoods("0000a83073","90","60","30","ww","93000");
goods[1918] =new setGoods("0000a82996","95","30","30","ww","46000");
goods[1919] =new setGoods("0000a83009","95","35","30","ww","54000");
goods[1920] =new setGoods("0000a83022","95","40","30","ww","62000");
goods[1921] =new setGoods("0000a83035","95","45","30","ww","70000");
goods[1922] =new setGoods("0000a83048","95","50","30","ww","78000");
goods[1923] =new setGoods("0000a83061","95","55","30","ww","86000");
goods[1924] =new setGoods("0000a83074","95","60","30","ww","94000");
goods[1925] =new setGoods("0000a82997","100","30","30","ww","47000");
goods[1926] =new setGoods("0000a83010","100","35","30","ww","55000");
goods[1927] =new setGoods("0000a83023","100","40","30","ww","63000");
goods[1928] =new setGoods("0000a83036","100","45","30","ww","71000");
goods[1929] =new setGoods("0000a83049","100","50","30","ww","79000");
goods[1930] =new setGoods("0000a83062","100","55","30","ww","87000");
goods[1931] =new setGoods("0000a83075","100","60","30","ww","95000");
goods[1932] =new setGoods("0000a82998","105","30","30","ww","48000");
goods[1933] =new setGoods("0000a83011","105","35","30","ww","56000");
goods[1934] =new setGoods("0000a83024","105","40","30","ww","64000");
goods[1935] =new setGoods("0000a83037","105","45","30","ww","72000");
goods[1936] =new setGoods("0000a83050","105","50","30","ww","80000");
goods[1937] =new setGoods("0000a83063","105","55","30","ww","88000");
goods[1938] =new setGoods("0000a83076","105","60","30","ww","96000");
goods[1939] =new setGoods("0000a82999","110","30","30","ww","49000");
goods[1940] =new setGoods("0000a83012","110","35","30","ww","57000");
goods[1941] =new setGoods("0000a83025","110","40","30","ww","65000");
goods[1942] =new setGoods("0000a83038","110","45","30","ww","73000");
goods[1943] =new setGoods("0000a83051","110","50","30","ww","81000");
goods[1944] =new setGoods("0000a83064","110","55","30","ww","89000");
goods[1945] =new setGoods("0000a83077","110","60","30","ww","97000");
goods[1946] =new setGoods("0000a83000","115","30","30","ww","50000");
goods[1947] =new setGoods("0000a83013","115","35","30","ww","58000");
goods[1948] =new setGoods("0000a83026","115","40","30","ww","66000");
goods[1949] =new setGoods("0000a83039","115","45","30","ww","74000");
goods[1950] =new setGoods("0000a83052","115","50","30","ww","82000");
goods[1951] =new setGoods("0000a83065","115","55","30","ww","90000");
goods[1952] =new setGoods("0000a83078","115","60","30","ww","98000");
goods[1953] =new setGoods("0000a83001","120","30","30","ww","51000");
goods[1954] =new setGoods("0000a83014","120","35","30","ww","59000");
goods[1955] =new setGoods("0000a83027","120","40","30","ww","67000");
goods[1956] =new setGoods("0000a83040","120","45","30","ww","75000");
goods[1957] =new setGoods("0000a83053","120","50","30","ww","83000");
goods[1958] =new setGoods("0000a83066","120","55","30","ww","91000");
goods[1959] =new setGoods("0000a83079","120","60","30","ww","99000");
goods[1960] =new setGoods("0000a83002","125","30","30","ww","52000");
goods[1961] =new setGoods("0000a83015","125","35","30","ww","60000");
goods[1962] =new setGoods("0000a83028","125","40","30","ww","68000");
goods[1963] =new setGoods("0000a83041","125","45","30","ww","76000");
goods[1964] =new setGoods("0000a83054","125","50","30","ww","84000");
goods[1965] =new setGoods("0000a83067","125","55","30","ww","92000");
goods[1966] =new setGoods("0000a83080","125","60","30","ww","100000");
goods[1967] =new setGoods("0000a83003","130","30","30","ww","53000");
goods[1968] =new setGoods("0000a83016","130","35","30","ww","61000");
goods[1969] =new setGoods("0000a83029","130","40","30","ww","69000");
goods[1970] =new setGoods("0000a83042","130","45","30","ww","77000");
goods[1971] =new setGoods("0000a83055","130","50","30","ww","85000");
goods[1972] =new setGoods("0000a83068","130","55","30","ww","93000");
goods[1973] =new setGoods("0000a83081","130","60","30","ww","101000");
goods[1974] =new setGoods("0000a83004","135","30","30","ww","54000");
goods[1975] =new setGoods("0000a83017","135","35","30","ww","62000");
goods[1976] =new setGoods("0000a83030","135","40","30","ww","70000");
goods[1977] =new setGoods("0000a83043","135","45","30","ww","78000");
goods[1978] =new setGoods("0000a83056","135","50","30","ww","86000");
goods[1979] =new setGoods("0000a83069","135","55","30","ww","94000");
goods[1980] =new setGoods("0000a83082","135","60","30","ww","102000");
goods[1981] =new setGoods("0000a83005","140","30","30","ww","55000");
goods[1982] =new setGoods("0000a83018","140","35","30","ww","63000");
goods[1983] =new setGoods("0000a83031","140","40","30","ww","71000");
goods[1984] =new setGoods("0000a83044","140","45","30","ww","79000");
goods[1985] =new setGoods("0000a83057","140","50","30","ww","87000");
goods[1986] =new setGoods("0000a83070","140","55","30","ww","95000");
goods[1987] =new setGoods("0000a83083","140","60","30","ww","103000");
goods[1988] =new setGoods("0000a83006","145","30","30","ww","56000");
goods[1989] =new setGoods("0000a83019","145","35","30","ww","64000");
goods[1990] =new setGoods("0000a83032","145","40","30","ww","72000");
goods[1991] =new setGoods("0000a83045","145","45","30","ww","80000");
goods[1992] =new setGoods("0000a83058","145","50","30","ww","88000");
goods[1993] =new setGoods("0000a83071","145","55","30","ww","96000");
goods[1994] =new setGoods("0000a83084","145","60","30","ww","104000");
goods[1995] =new setGoods("0000a83007","150","30","30","ww","57000");
goods[1996] =new setGoods("0000a83020","150","35","30","ww","65000");
goods[1997] =new setGoods("0000a83033","150","40","30","ww","73000");
goods[1998] =new setGoods("0000a83046","150","45","30","ww","81000");
goods[1999] =new setGoods("0000a83059","150","50","30","ww","89000");
goods[2000] =new setGoods("0000a83072","150","55","30","ww","97000");
goods[2001] =new setGoods("0000a83085","150","60","30","ww","105000");
goods[2002] =new setGoods("0000a83086","90","30","42","ww","50000");
goods[2003] =new setGoods("0000a83087","95","30","42","ww","51000");
goods[2004] =new setGoods("0000a83088","100","30","42","ww","52000");
goods[2005] =new setGoods("0000a83089","105","30","42","ww","53000");
goods[2006] =new setGoods("0000a83090","110","30","42","ww","54000");
goods[2007] =new setGoods("0000a83091","115","30","42","ww","55000");
goods[2008] =new setGoods("0000a83092","120","30","42","ww","56000");
goods[2009] =new setGoods("0000a83093","125","30","42","ww","57000");
goods[2010] =new setGoods("0000a83094","130","30","42","ww","58000");
goods[2011] =new setGoods("0000a83095","135","30","42","ww","59000");
goods[2012] =new setGoods("0000a83096","140","30","42","ww","60000");
goods[2013] =new setGoods("0000a83097","145","30","42","ww","61000");
goods[2014] =new setGoods("0000a83098","150","30","42","ww","62000");
goods[2015] =new setGoods("0000a83099","90","35","42","ww","58000");
goods[2016] =new setGoods("0000a83100","95","35","42","ww","59000");
goods[2017] =new setGoods("0000a83101","100","35","42","ww","60000");
goods[2018] =new setGoods("0000a83102","105","35","42","ww","61000");
goods[2019] =new setGoods("0000a83103","110","35","42","ww","62000");
goods[2020] =new setGoods("0000a83104","115","35","42","ww","63000");
goods[2021] =new setGoods("0000a83105","120","35","42","ww","64000");
goods[2022] =new setGoods("0000a83106","125","35","42","ww","65000");
goods[2023] =new setGoods("0000a83107","130","35","42","ww","66000");
goods[2024] =new setGoods("0000a83108","135","35","42","ww","67000");
goods[2025] =new setGoods("0000a83109","140","35","42","ww","68000");
goods[2026] =new setGoods("0000a83110","145","35","42","ww","69000");
goods[2027] =new setGoods("0000a83111","150","35","42","ww","70000");
goods[2028] =new setGoods("0000a83112","90","40","42","ww","66000");
goods[2029] =new setGoods("0000a83113","95","40","42","ww","67000");
goods[2030] =new setGoods("0000a83114","100","40","42","ww","68000");
goods[2031] =new setGoods("0000a83115","105","40","42","ww","69000");
goods[2032] =new setGoods("0000a83116","110","40","42","ww","70000");
goods[2033] =new setGoods("0000a83117","115","40","42","ww","71000");
goods[2034] =new setGoods("0000a83118","120","40","42","ww","72000");
goods[2035] =new setGoods("0000a83119","125","40","42","ww","73000");
goods[2036] =new setGoods("0000a83120","130","40","42","ww","74000");
goods[2037] =new setGoods("0000a83121","135","40","42","ww","75000");
goods[2038] =new setGoods("0000a83122","140","40","42","ww","76000");
goods[2039] =new setGoods("0000a83123","145","40","42","ww","77000");
goods[2040] =new setGoods("0000a83124","150","40","42","ww","78000");
goods[2041] =new setGoods("0000a83125","90","45","42","ww","74000");
goods[2042] =new setGoods("0000a83126","95","45","42","ww","75000");
goods[2043] =new setGoods("0000a83127","100","45","42","ww","76000");
goods[2044] =new setGoods("0000a83128","105","45","42","ww","77000");
goods[2045] =new setGoods("0000a83129","110","45","42","ww","78000");
goods[2046] =new setGoods("0000a83130","115","45","42","ww","79000");
goods[2047] =new setGoods("0000a83131","120","45","42","ww","80000");
goods[2048] =new setGoods("0000a83132","125","45","42","ww","81000");
goods[2049] =new setGoods("0000a83133","130","45","42","ww","82000");
goods[2050] =new setGoods("0000a83134","135","45","42","ww","83000");
goods[2051] =new setGoods("0000a83135","140","45","42","ww","84000");
goods[2052] =new setGoods("0000a83136","145","45","42","ww","85000");
goods[2053] =new setGoods("0000a83137","150","45","42","ww","86000");
goods[2054] =new setGoods("0000a83138","90","50","42","ww","82000");
goods[2055] =new setGoods("0000a83139","95","50","42","ww","83000");
goods[2056] =new setGoods("0000a83140","100","50","42","ww","84000");
goods[2057] =new setGoods("0000a83141","105","50","42","ww","85000");
goods[2058] =new setGoods("0000a83142","110","50","42","ww","86000");
goods[2059] =new setGoods("0000a83143","115","50","42","ww","87000");
goods[2060] =new setGoods("0000a83144","120","50","42","ww","88000");
goods[2061] =new setGoods("0000a83145","125","50","42","ww","89000");
goods[2062] =new setGoods("0000a83146","130","50","42","ww","90000");
goods[2063] =new setGoods("0000a83147","135","50","42","ww","91000");
goods[2064] =new setGoods("0000a83148","140","50","42","ww","92000");
goods[2065] =new setGoods("0000a83149","145","50","42","ww","93000");
goods[2066] =new setGoods("0000a83150","150","50","42","ww","94000");
goods[2067] =new setGoods("0000a83151","90","55","42","ww","90000");
goods[2068] =new setGoods("0000a83152","95","55","42","ww","91000");
goods[2069] =new setGoods("0000a83153","100","55","42","ww","92000");
goods[2070] =new setGoods("0000a83154","105","55","42","ww","93000");
goods[2071] =new setGoods("0000a39428","110","55","42","ww","94000");
goods[2072] =new setGoods("0000a83155","115","55","42","ww","95000");
goods[2073] =new setGoods("0000a83156","120","55","42","ww","96000");
goods[2074] =new setGoods("0000a83157","125","55","42","ww","97000");
goods[2075] =new setGoods("0000a83158","130","55","42","ww","98000");
goods[2076] =new setGoods("0000a83159","135","55","42","ww","99000");
goods[2077] =new setGoods("0000a83160","140","55","42","ww","100000");
goods[2078] =new setGoods("0000a83161","145","55","42","ww","101000");
goods[2079] =new setGoods("0000a83162","150","55","42","ww","102000");
goods[2080] =new setGoods("0000a83163","90","60","42","ww","98000");
goods[2081] =new setGoods("0000a83164","95","60","42","ww","99000");
goods[2082] =new setGoods("0000a83165","100","60","42","ww","100000");
goods[2083] =new setGoods("0000a83166","105","60","42","ww","101000");
goods[2084] =new setGoods("0000a83167","110","60","42","ww","102000");
goods[2085] =new setGoods("0000a83168","115","60","42","ww","103000");
goods[2086] =new setGoods("0000a83169","120","60","42","ww","104000");
goods[2087] =new setGoods("0000a83170","125","60","42","ww","105000");
goods[2088] =new setGoods("0000a83171","130","60","42","ww","106000");
goods[2089] =new setGoods("0000a83172","135","60","42","ww","107000");
goods[2090] =new setGoods("0000a83173","140","60","42","ww","108000");
goods[2091] =new setGoods("0000a83174","145","60","42","ww","109000");
goods[2092] =new setGoods("0000a83175","150","60","42","ww","110000");
goods[2093] =new setGoods("0000a83176","90","30","50","ww","55000");
goods[2094] =new setGoods("0000a83189","90","35","50","ww","63000");
goods[2095] =new setGoods("0000a83202","90","40","50","ww","71000");
goods[2096] =new setGoods("0000a83215","90","45","50","ww","79000");
goods[2097] =new setGoods("0000a83228","90","50","50","ww","87000");
goods[2098] =new setGoods("0000a83241","90","55","50","ww","95000");
goods[2099] =new setGoods("0000a83254","90","60","50","ww","103000");
goods[2100] =new setGoods("0000a83177","95","30","50","ww","56000");
goods[2101] =new setGoods("0000a83190","95","35","50","ww","64000");
goods[2102] =new setGoods("0000a83203","95","40","50","ww","72000");
goods[2103] =new setGoods("0000a83216","95","45","50","ww","80000");
goods[2104] =new setGoods("0000a83229","95","50","50","ww","88000");
goods[2105] =new setGoods("0000a83242","95","55","50","ww","96000");
goods[2106] =new setGoods("0000a83255","95","60","50","ww","104000");
goods[2107] =new setGoods("0000a83178","100","30","50","ww","57000");
goods[2108] =new setGoods("0000a83191","100","35","50","ww","65000");
goods[2109] =new setGoods("0000a83204","100","40","50","ww","73000");
goods[2110] =new setGoods("0000a83217","100","45","50","ww","81000");
goods[2111] =new setGoods("0000a83230","100","50","50","ww","89000");
goods[2112] =new setGoods("0000a83243","100","55","50","ww","97000");
goods[2113] =new setGoods("0000a83256","100","60","50","ww","105000");
goods[2114] =new setGoods("0000a83179","105","30","50","ww","58000");
goods[2115] =new setGoods("0000a83192","105","35","50","ww","66000");
goods[2116] =new setGoods("0000a83205","105","40","50","ww","74000");
goods[2117] =new setGoods("0000a83218","105","45","50","ww","82000");
goods[2118] =new setGoods("0000a83231","105","50","50","ww","90000");
goods[2119] =new setGoods("0000a83244","105","55","50","ww","98000");
goods[2120] =new setGoods("0000a83257","105","60","50","ww","106000");
goods[2121] =new setGoods("0000a83180","110","30","50","ww","59000");
goods[2122] =new setGoods("0000a83193","110","35","50","ww","67000");
goods[2123] =new setGoods("0000a83206","110","40","50","ww","75000");
goods[2124] =new setGoods("0000a83219","110","45","50","ww","83000");
goods[2125] =new setGoods("0000a83232","110","50","50","ww","91000");
goods[2126] =new setGoods("0000a83245","110","55","50","ww","99000");
goods[2127] =new setGoods("0000a83258","110","60","50","ww","107000");
goods[2128] =new setGoods("0000a83181","115","30","50","ww","60000");
goods[2129] =new setGoods("0000a83194","115","35","50","ww","68000");
goods[2130] =new setGoods("0000a83207","115","40","50","ww","76000");
goods[2131] =new setGoods("0000a83220","115","45","50","ww","84000");
goods[2132] =new setGoods("0000a83233","115","50","50","ww","92000");
goods[2133] =new setGoods("0000a83246","115","55","50","ww","100000");
goods[2134] =new setGoods("0000a83259","115","60","50","ww","108000");
goods[2135] =new setGoods("0000a83182","120","30","50","ww","61000");
goods[2136] =new setGoods("0000a83195","120","35","50","ww","69000");
goods[2137] =new setGoods("0000a83208","120","40","50","ww","77000");
goods[2138] =new setGoods("0000a83221","120","45","50","ww","85000");
goods[2139] =new setGoods("0000a83234","120","50","50","ww","93000");
goods[2140] =new setGoods("0000a83247","120","55","50","ww","101000");
goods[2141] =new setGoods("0000a83260","120","60","50","ww","109000");
goods[2142] =new setGoods("0000a83183","125","30","50","ww","62000");
goods[2143] =new setGoods("0000a83196","125","35","50","ww","70000");
goods[2144] =new setGoods("0000a83209","125","40","50","ww","78000");
goods[2145] =new setGoods("0000a83222","125","45","50","ww","86000");
goods[2146] =new setGoods("0000a83235","125","50","50","ww","94000");
goods[2147] =new setGoods("0000a83248","125","55","50","ww","102000");
goods[2148] =new setGoods("0000a83261","125","60","50","ww","110000");
goods[2149] =new setGoods("0000a83184","130","30","50","ww","63000");
goods[2150] =new setGoods("0000a83197","130","35","50","ww","71000");
goods[2151] =new setGoods("0000a83210","130","40","50","ww","79000");
goods[2152] =new setGoods("0000a83223","130","45","50","ww","87000");
goods[2153] =new setGoods("0000a83236","130","50","50","ww","95000");
goods[2154] =new setGoods("0000a83249","130","55","50","ww","103000");
goods[2155] =new setGoods("0000a83262","130","60","50","ww","111000");
goods[2156] =new setGoods("0000a83185","135","30","50","ww","64000");
goods[2157] =new setGoods("0000a83198","135","35","50","ww","72000");
goods[2158] =new setGoods("0000a83211","135","40","50","ww","80000");
goods[2159] =new setGoods("0000a83224","135","45","50","ww","88000");
goods[2160] =new setGoods("0000a83237","135","50","50","ww","96000");
goods[2161] =new setGoods("0000a83250","135","55","50","ww","104000");
goods[2162] =new setGoods("0000a83263","135","60","50","ww","112000");
goods[2163] =new setGoods("0000a83186","140","30","50","ww","65000");
goods[2164] =new setGoods("0000a83199","140","35","50","ww","73000");
goods[2165] =new setGoods("0000a83212","140","40","50","ww","81000");
goods[2166] =new setGoods("0000a83225","140","45","50","ww","89000");
goods[2167] =new setGoods("0000a83238","140","50","50","ww","97000");
goods[2168] =new setGoods("0000a83251","140","55","50","ww","105000");
goods[2169] =new setGoods("0000a83264","140","60","50","ww","113000");
goods[2170] =new setGoods("0000a83187","145","30","50","ww","66000");
goods[2171] =new setGoods("0000a83200","145","35","50","ww","74000");
goods[2172] =new setGoods("0000a83213","145","40","50","ww","82000");
goods[2173] =new setGoods("0000a83226","145","45","50","ww","90000");
goods[2174] =new setGoods("0000a83239","145","50","50","ww","98000");
goods[2175] =new setGoods("0000a83252","145","55","50","ww","106000");
goods[2176] =new setGoods("0000a83265","145","60","50","ww","114000");
goods[2177] =new setGoods("0000a83188","150","30","50","ww","67000");
goods[2178] =new setGoods("0000a83201","150","35","50","ww","75000");
goods[2179] =new setGoods("0000a83214","150","40","50","ww","83000");
goods[2180] =new setGoods("0000a83227","150","45","50","ww","91000");
goods[2181] =new setGoods("0000a83240","150","50","50","ww","99000");
goods[2182] =new setGoods("0000a83253","150","55","50","ww","107000");
goods[2183] =new setGoods("0000a83266","150","60","50","ww","115000");